import {faCircle} from '@fortawesome/free-solid-svg-icons/faCircle';
import {
  areaAssignmentDataTableRestrictionEnumOptions,
  areaWizardProductsEnumModel,
  CorePortalContactService,
  CorePortalDatatableStandardConfig,
  CorePortalFunctionService,
  corePortalGetDatatableConfigDefaults,
  CorePortalLocationService,
  CorePortalSettingsRoleProductRelevantService,
  CorePortalStereotypeService,
  DatatableTableColumnType
} from '@app/core-portal';
import {CorePortalFeatureArticleKindService} from '@app/core-portal/features/articles';
import {CorePortalFeatureMasterDataAddressService} from '@app/core-portal/features/master-data/features/addresses';
import {CorePortalFeatureMasterDataLocationGroupService} from '@app/core-portal/features/master-data/features/location-groups';
import {
  CorePortalFeatureMasterDataLocationService,
  locationStateEnumOptions
} from '@app/core-portal/features/master-data/features/locations';
import {CorePortalFeatureResourceService} from '@app/core-portal/features/resources';
import {
  tenantSubscriptionKindOptions,
  tenantSubscriptionTypeEnumOptions
} from '@app/core-portal/features/service';
import {
  AddressSimpleDto,
  AppEntityType,
  AppPermissions,
  brandOptions,
  CategorizedRelationDto,
  CategorizedType,
  CategorySector,
  clientOptions,
  CombineOperator,
  ConsumptionCodeSimpleListDto,
  ContactInMissionListDto,
  ContactSimpleDto,
  ContractDto,
  ControlSimpleDto,
  CoreSharedCategoryService,
  ErrorCodeSimpleListDto,
  EscalationLevelSimpleDto,
  Filter,
  FilterOperators,
  FilterTypes,
  FunctionSimpleDto,
  GlobalStateColor,
  HintCodeSimpleListDto,
  InfoDto,
  IssueTemplateDto,
  KnowledgePathSimpleListDto,
  LocationDto,
  LocationGroupRelationListDto,
  LocationRelationListDto,
  LocationSimpleDto,
  LocationSimpleListDto,
  MissionCompleteDto,
  MissionDto,
  MissionIssueListDto,
  MissionSimpleListDto,
  ProductSubscriptionDto,
  ResourceDto,
  ResourceInTicketDto,
  ResourceManufacturerListDto,
  ResourceModelListDto,
  ResourceSimpleDto,
  ResourceTaskSimpleDto,
  RoleInAreaListDto,
  StateDto,
  StereotypeSimpleDto,
  TaskDto,
  TicketDto,
  TicketSimpleDto,
  TicketSimpleListDto
} from '@app/core-shared';
import {categorySectorEnumOptions} from '@app/orga-portal/features/categories';
import {platformEnumOptions} from '@app/orga-portal/features/devices';
import {
  executionPlanEnumOptions,
  OrgaPortalFeatureTaskService,
  taskJobStateEnumOptions,
  taskStatesEnumOptions,
  taskTypeEnumOptions
} from '@app/orga-portal/features/tasks';
import {
  TechPortalIssueTemplateService,
  TechPortalMissionService,
  TechPortalTicketService
} from '@app/tech-portal-lib';
import {contractStateEnumOptions} from '@app/tech-portal/features/contracts';
import {
  releaseEntryStatusTypesEnumOptions,
  releaseMonitorErpTriggerReasonsEnumOptions,
  releaseMonitorErpTypesEnumOptions,
  techPortalFeatureMissionQuestStateEnumOptions,
  TechPortalFeatureMissionService,
  techPortalFeatureMissionStateEnumOptions
} from '@app/tech-portal/features/missions';
import {TechPortalFeatureResourceTaskService} from '@app/tech-portal/features/resource-tasks';
import {documentContextTypeEnumOptions, textContextTypeEnumOptions} from '@app/tech-portal/features/templates';
import {TechPortalFeatureTicketSettingsEscalationLevelService} from '@app/tech-portal/features/ticket-settings/features/escalation-levels';
import {TechPortalFeatureTicketSettingsPriorityService} from '@app/tech-portal/features/ticket-settings/features/priority-sets';
import {TechPortalFeatureTicketSettingsStateService} from '@app/tech-portal/features/ticket-settings/features/states';
import {of} from 'rxjs';
import {infoStateEnumOptions} from "@app/orga-portal/features/infos";
import {resourceTypeEnumOptions} from "@app/tech-portal/features/resources";
import {
  CorePortalManufacturerService,
  CorePortalModelService
} from "@app/core-portal/features/settings/features/manufacturers";
import {resourceStateEnumOptions} from "@app/tech-portal/features/resources/src/lib/models";
import {invitationPurposeEnumOptions} from "@app/core-portal/features/settings/features/invitations";
import {
  issueContentTypeEnumOptions,
  issueTypeEnumOptions
} from "@app/tech-portal/features/issues/src/lib/models";
import {
  controlConditionTypeEnumOptions,
  TechPortalFeatureControlService
} from "@app/tech-portal/features/controls";
import {TechPortalFeatureConnectedErrorCodeService} from "@app/tech-portal/features/connected/error-codes";
import {TechPortalFeatureConnectedConsumptionCodeService} from "@app/tech-portal/features/connected/consumption-codes";
import {importProtocolStatusEnumOptions} from "@app/core-portal/features/settings/features/mass-import/src/lib/models";
import {controlIssueReasonTypeEnumOptions} from "@app/tech-portal/features/controls/src/lib/models/control-issue-type-enum.model";
import {noteDirectionOptions} from "@app/tech-portal/features/solution/src/lib/components";
import {mailInStatusTypeEnumOptions} from "@app/core-portal/features/settings/features/mail-logs/src/lib/models/main-in-status-types";
import {knowledgePathProgressStatusEnumOptions} from "@app/core-portal/features/master-data/features/contacts";
import {ContactKnowledgePathProgressService} from "@app/core-portal/features/master-data/features/contacts/src/lib/store";
import {wageListTravelCalculationModeEnumOptions} from "@app/core-portal/features/settings/features/missions";
import {faExclamation} from "@fortawesome/free-solid-svg-icons/faExclamation";
import {TechPortalFeatureConnectedHintCodeService} from "@app/tech-portal/features/connected/hint-codes";
import {deviceStatusEnumOptions} from "@app/orga-portal/features/devices/src/lib/models";

const taskExecutionsDefault: any = {
  excludedColumns: [
    'task.taskId',
    'task.title',
    'task.description',
    'task.type',
    'task.children',
    'task.formId',
    'task.requiresAuthentication',
    'task.hasStrictOrder',
    'task.position',
    'task.reasonSetId',
    'task.categoryRelations',
    'jobStatus',
    'children',
    'parentId',
    'locationId',
    'taskId',
    'filledFormId',
    'locationNumber',
    'locationName',
    'location.name',
    'location.locationId',
    'location.locationNumber',
    'attachment',
    'attachment.attachmentId',
    'attachment.tenantId',
    'attachment.type',
    'attachment.name',
    'attachment.url',
    'attachment.link',
    'attachment.path',
    'attachment.referenceId',
    'attachment.infoId',
    'currentJobStatus',
    'currentJobStatus.taskJobStatusId',
    'currentJobStatus.reason',
    'currentJobStatus.reason.taskJobStateReasonId',
    'currentJobStatus.reason.tenantId',
    'currentJobStatus.status',
    'location.externalId'
  ],
  defaultColumns: [
    'taskJobId',
    'title',
    'executionDate',
    'currentStatus',
    'location'
  ],
  columnTypings: [
    {
      key: 'task',
      type: DatatableTableColumnType.REFERENCE,
      idKey: 'taskId',
      displayKey: 'title',
      service: OrgaPortalFeatureTaskService,
      link: (task: TaskDto) => task?.taskId ? `/tasks/${ task.taskId }` : null,
      module: 'communication',
      permissions: [AppPermissions.ReadTask],
      linkPermissions: [AppPermissions.ReadTask]
    },
    {
      key: 'title',
      type: DatatableTableColumnType.TEXT,
      name: 'title'
    },
    {
      key: 'executionDate',
      type: DatatableTableColumnType.DATE,
      utc: true
    },
    {
      key: 'currentStatus',
      type: DatatableTableColumnType.ENUM,
      name: 'current-state',
      enumOptions: taskJobStateEnumOptions
    },
    {
      key: 'location',
      type: DatatableTableColumnType.REFERENCE,
      idKey: 'locationId',
      displayKey: 'name',
      service: CorePortalFeatureMasterDataLocationService,
      link: (location: LocationSimpleDto) => location?.locationId ?
        `/masterdata/locations/${ location.locationId }` : null,
      module: 'management',
      permissions: [AppPermissions.ReadLocation],
      linkPermissions: [AppPermissions.ReadLocation]
    }
  ]
};

export function provideDatatableStandardConfig(): CorePortalDatatableStandardConfig {
  return {
    ...corePortalGetDatatableConfigDefaults(),
    ...provideManagementDatatableConfig(),
    ...provideCommunicationDatatableConfig(),
    ...provideInventoryDatatableConfig(),
    ...provideServiceDatatableConfig(),
    ...provideSettingsDatatableConfig()
  };
}

function provideManagementDatatableConfig(): CorePortalDatatableStandardConfig {
  const dashboardTaskHistoryDefault: any = {
    excludedColumns: [
      'identifier',
      'locationId',
      'taskId'
    ],
    columnTypings: [
      {
        key: 'taskTitle',
        name: 'task',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'taskId',
        displayKey: 'title',
        service: OrgaPortalFeatureTaskService,
        filterProp: 'taskId',
        multiple: false,
        template: (task: string | TaskDto) => typeof task === 'string' ? task : task?.title,
        clickable: true
      },
      {
        key: 'locationName',
        name: 'location',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'locationId',
        displayKey: 'name',
        service: CorePortalLocationService,
        filterProp: 'locationId',
        multiple: false,
        template: (location: string | LocationSimpleDto) => typeof location === 'string' ? location : location?.name,
        clickable: true
      },

      { key: 'countStart', type: DatatableTableColumnType.NUMBER, disableFilter: true },
      { key: 'countOpen', type: DatatableTableColumnType.NUMBER, disableFilter: true },
      { key: 'countOverdue', type: DatatableTableColumnType.NUMBER, disableFilter: true },
      { key: 'countEscalated', type: DatatableTableColumnType.NUMBER, disableFilter: true },
      { key: 'countDone', type: DatatableTableColumnType.NUMBER, disableFilter: true },
      { key: 'countCanceled', type: DatatableTableColumnType.NUMBER, disableFilter: true }
    ]
  };

  return {
    /* Dashboard */
    DashboardOverviewTaskDefault: {
      excludedColumns: [
        'isAny',
        'identifier'
      ],
      defaultColumns: [
        'name',
        'countPending',
        'countOpen',
        'countOverdue',
        'countEscalated',
        'countDone',
        'countCanceled',
      ],
      columnTypings: [
        { key: 'name', type: DatatableTableColumnType.TEXT, clickable: true },
        { key: 'countPending', type: DatatableTableColumnType.NUMBER },
        { key: 'countOpen', name: 'count-start', type: DatatableTableColumnType.NUMBER },
        { key: 'countOverdue', type: DatatableTableColumnType.NUMBER },
        { key: 'countEscalated', type: DatatableTableColumnType.NUMBER },
        { key: 'countDone', type: DatatableTableColumnType.NUMBER },
        { key: 'countCanceled', type: DatatableTableColumnType.NUMBER }
      ]
    },
    DashboardTaskHistoryByLocation: {
      ...dashboardTaskHistoryDefault,
      defaultColumns: [
        'locationName',
        'countStart',
        'countOverdue',
        'countEscalated',
        'countDone',
        'countCanceled'
      ]
    },
    DashboardTaskHistoryByTask: {
      ...dashboardTaskHistoryDefault,
      excludedColumns: [
        ...dashboardTaskHistoryDefault.excludedColumns,
        'date'
      ],
      defaultColumns: [
        'taskTitle',
        'countStart',
        'countOverdue',
        'countEscalated',
        'countDone',
        'countCanceled'
      ]
    },

    /* Master Data */
    MasterDataContactDefault: {
      excludedColumns: [
        'customPropertyValues',
        'isInRelation',
        'position',
        'tenantId',
        'stereotypeId',
        'stereotypeRowVersion',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.emoji',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'user',
        'user.id'
      ],
      defaultColumns: [
        'contactId',
        'firstName',
        'lastName',
        'displayName',
        'user.email',
        'pin',
        'stereotype',
        'lockedSince',
        'loginExpiration'
      ],
      columnTypings: [
        {
          key: 'pin',
          type: DatatableTableColumnType.TEXT,
          hideByDefault: true
        },
        {
          key: 'user.email',
          type: DatatableTableColumnType.TEXT,
          name: 'email-address'
        },
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'isFree',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'is-active'
        },
        {
          key: 'lockedSince',
          type: DatatableTableColumnType.DATE,
          name: 'locked-out-date',
          utc: true
        },
        {
          key: 'loginExpiration',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'user.lastLoggedIn',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'last-logged-in'
        },
        {
          key: 'mobile',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'phone',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'locations',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          multiple: true,
          separator: ', '
        },
        {
          key: 'locationGroups',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationGroupId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationGroupService,
          multiple: true,
          separator: ', '
        },
        {
          key: 'functions',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'functionId',
          displayKey: 'name',
          service: CorePortalFunctionService,
          multiple: true,
          separator: ', '
        },
        {
          key: 'roles',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'appRoleId',
          displayKey: 'title',
          service: CorePortalSettingsRoleProductRelevantService,
          multiple: true,
          separator: ', '
        },
      ]
    },
    MasterDataContactOpenEditorRequestDefault: {
      excludedColumns: [
        'mission.missionId',
        'mission.type',
        'mission.title',
        'mission.tenantId',
        'mission.state',
        'mission.plannedStart',
        'mission.plannedEnd',
        'mission.location',
        'mission.location.locationId',
        'mission.location.name',
        'mission.location.locationNumber',
        'mission.location.externalId',
        'mission.resource',
        'mission.resource.resourceId',
        'mission.resource.name',
        'mission.resource.inventoryNumberCount',
        'mission.resource.inventoryNumber',
        'mission.resource.locationId',
        'mission.resource.parentId',
        'mission.resource.location',
        'mission.resource.location.locationId',
        'mission.resource.location.name',
        'mission.resource.location.locationNumber',
        'mission.resource.location.externalId',
        'mission.resource.stereotype',
        'mission.resource.stereotype.stereotypeId',
        'mission.resource.stereotype.name',
        'mission.resource.stereotype.position',
        'mission.resource.stereotype.emoji',
        'mission.resource.stereotype.tenantId',
        'mission.resource.stereotype.rowVersion',
        'mission.resource.stereotype.isArchived',
        'mission.resource.stereotype.externalId',
        'mission.resource.externalId',
        'mission.resource.isArchived',
        'mission.resource.path',
        'editorRequestId'
      ],
      defaultColumns: [
        'missionId',
        'mission',
        'createdAt'
      ],
      columnTypings: [
        {
          key: 'missionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'mission-id'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        }
      ]
    },
    MasterDataContactKnowledgePathProgressDefault: {
      excludedColumns: [
        'certificate',
        'certificate.fileId',
        'certificate.tenantId',
        'certificate.path',
        'certificate.creationDateTime',
        'certificate.mimeType',
        'certificate.size',
        'certificate.uri',
        'certificate.hash',
        'knowledgePath.knowledgePathId',
        'knowledgePath.title',
        'knowledgePath.tenantId',
      ],
      defaultColumns: [
        'knowledgePathProgressId',
        'knowledgePath',
        'status',
        'completionDate',
        'averageScore',
        'certificate.name',
      ],
      columnTypings: [
        {
          key: 'knowledgePathProgressId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'knowledgePath',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'knowledgePathId',
          displayKey: 'title',
          service: ContactKnowledgePathProgressService,
          link: (knowledgePath: KnowledgePathSimpleListDto) => knowledgePath?.knowledgePathId ?
            `/knowledge/paths/${ knowledgePath?.knowledgePathId }` : null,
          module: 'communication'
        },
        {
          key: 'locationId',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'status',
          type: DatatableTableColumnType.ENUM,
          enumOptions: knowledgePathProgressStatusEnumOptions,
          name: 'status'
        },
        {
          key: 'completionDate',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'averageScore',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'certificate.name',
          type: DatatableTableColumnType.LINK,
          clickable: true,
          name: 'certificate'
        },
      ]
    },
    MasterDataFunctionDefault: {
      excludedColumns: [
        'customPropertyValues',
        'isInRelation',
        'tenantId',
        'stereotypeId',
        'stereotypeRowVersion',
        'rowVersion',
        'isArchived',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'phone', // ToDo: Use in the future
        'email' // ToDo: Use in the future
      ],
      defaultColumns: [
        'functionId',
        'name',
        'stereotype'
      ],
      columnTypings: []
    },
    MasterDataLocationDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion',
        'geoLatitude',
        'geoLongitude',
        'stereotypeRowVersion',
        'customPropertyValues',
        'stereotypeId',
        'isInRelation',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',

        'invoiceAddress.tenantId',
        'invoiceAddress.rowVersion',
        'invoiceAddress.stereotypeRowVersion',
        'invoiceAddress.customPropertyValues',
        'invoiceAddress.addressId',
        'invoiceAddress.stereotypeId',
        'invoiceAddress.stereotype.stereotypeId',
        'invoiceAddress.stereotype.name',
        'invoiceAddress.stereotype.tenantId',
        'invoiceAddress.stereotype.rowVersion',
        'invoiceAddress.stereotype.isArchived',

        'shippingAddress.tenantId',
        'shippingAddress.rowVersion',
        'shippingAddress.stereotypeRowVersion',
        'shippingAddress.customPropertyValues',
        'shippingAddress.addressId',
        'shippingAddress.stereotypeId',
        'shippingAddress.stereotype.stereotypeId',
        'shippingAddress.stereotype.name',
        'shippingAddress.stereotype.tenantId',
        'shippingAddress.stereotype.rowVersion',
        'shippingAddress.stereotype.isArchived',
      ],
      defaultColumns: [
        'locationId',
        'name',
        'stereotype',
        'state'
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'phoneNumber',
          type: DatatableTableColumnType.PHONE,
          name: 'phone'
        },
        {
          key: 'state',
          type: DatatableTableColumnType.ENUM,
          name: 'current-state',
          enumOptions: locationStateEnumOptions
        }
      ]
    },
    MasterDataLocationGroupDefault: {
      excludedColumns: [
        'tenantId',
        'type',
        'isSystem',
        'rowVersion',
        'isInRelation',
        'stereotypeId',
        'stereotypeRowVersion',
        'customPropertyValues',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
      ],
      defaultColumns: [
        'locationGroupId',
        'name',
        'stereotype'
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },
    MasterDataCompanyDefault: {
      excludedColumns: [
        'tenantId',
        'parentCompanyId',
        'rowVersion',
        'stereotypeId',
        'customPropertyValues',
        'stereotypeRowVersion',
        'isInRelation',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.emoji',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId'
      ],
      defaultColumns: [
        'companyId',
        'name',
        'stereotype'
      ],
      columnTypings: []
    },
    MasterDataAddressDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion',
        'stereotypeId',
        'customPropertyValues',
        'stereotypeRowVersion',
        'isInRelation',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'point.lat',
        'point.lng',
        'point',
      ],
      defaultColumns: [
        'addressId',
        'street',
        'houseNumber',
        'city',
        'state',
        'zipcode',
        'countryCode',
        'stereotype'
      ],
      columnTypings: []
    },
    MasterDataHolidaysDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'holidaySetId',
        'name'
      ],
      columnTypings: []
    },
    MasterDataAreaAssignmentDefault: {
      excludedColumns: [
        'tenantId',
        'contact.contactId',
        'contact.displayName',
        'contact.externalId'
      ],
      defaultColumns: [
        'areaAssignmentId',
        'product',
        'locations',
        'locationGroups',
        'functions',
        'roles',
        'dataTableRestriction'
      ],
      columnTypings: [
        {
          key: 'areaAssignmentId',
          type: DatatableTableColumnType.TEXT,
          name: 'id',
          clickable: true
        },
        {
          key: 'product',
          type: DatatableTableColumnType.ENUM,
          enumOptions: areaWizardProductsEnumModel
        },
        {
          key: 'addition',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'lastSynchronizedAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'dataTableRestriction',
          type: DatatableTableColumnType.ENUM,
          enumOptions: areaAssignmentDataTableRestrictionEnumOptions,
          name: 'resources'
        },
        {
          key: 'locations',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          mapValues: (locations: LocationRelationListDto[]) => locations.map(x => x.location),
          filterProp: 'locations',
          multiple: true,
          separator: ', '
        },
        {
          key: 'locationGroups',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationGroupId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationGroupService,
          mapValues: (locationGroups: LocationGroupRelationListDto[]) => locationGroups.map(x => x.locationGroup),
          filterProp: 'locationGroups',
          multiple: true,
          separator: ', '
        },
        {
          key: 'roles',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'appRoleId',
          displayKey: 'title',
          service: CorePortalSettingsRoleProductRelevantService,
          mapValues: (roles: RoleInAreaListDto[]) => roles.map(x => ({
            ...x.role,
            appRoleId: x.roleId,
            title: x.role.name
          })),
          filterProp: 'roles',
          multiple: true,
          separator: ', '
        },
        {
          key: 'functions',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'functionId',
          displayKey: 'name',
          service: CorePortalFunctionService,
          mapValues: (functions: { function: FunctionSimpleDto }[]) => functions.map(x => x.function),
          filterProp: 'functions',
          multiple: true,
          separator: ', '
        },
        {
          key: 'contact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          name: 'contact',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact) => contact?.contactId ?
            `/masterdata/contacts/${ contact?.contactId }` : null,
          module: 'management'
        }
      ]
    },

    // Location task jobs
    LocationTaskArchiveDefault: {
      excludedColumns: [
        ...taskExecutionsDefault.excludedColumns,
        'generationKind',
        'finishDate'
      ],
      defaultColumns: [
        'taskJobId',
        'executionDate',
        'currentStatus',
        'task',
        'currentJobStatus.createdByContactName',
        'currentJobStatus.reason.content',
        'attachment'
      ],
      columnTypings: [
        ...taskExecutionsDefault.columnTypings.filter(typing => typing.key !== 'task'),
        {
          key: 'task',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'taskId',
          displayKey: 'title',
          service: OrgaPortalFeatureTaskService,
          link: (task: TaskDto) => task?.taskId ? `/tasks/${ task.taskId }` : null,
          module: 'communication',
          permissions: [AppPermissions.ReadTask],
          linkPermissions: [AppPermissions.ReadTask],
          filters$: of([
            {
              property: 'parentId',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: null
            },
            {
              type: FilterTypes.Grouped,
              combinedAs: CombineOperator.And,
              children: [
                {
                  property: 'state',
                  type: FilterTypes.DataTransferObject,
                  operator: FilterOperators.NotEqual,
                  value: '3'
                },
                {
                  property: 'state',
                  type: FilterTypes.DataTransferObject,
                  operator: FilterOperators.NotEqual,
                  value: '2'
                }
              ]
            }
          ] as Filter[]),
        },
        {
          key: 'currentJobStatus.createdByContactName',
          type: DatatableTableColumnType.TEXT,
          name: 'created-by-user-name'
        },
        {
          key: 'currentJobStatus.reason.content',
          type: DatatableTableColumnType.TEXT,
          name: 'reason'
        }
      ],
    },
    LocationTaskArchiveActive: {
      excludedColumns: [
        ...taskExecutionsDefault.excludedColumns,
        'generationKind',
        'finishDate'
      ],
      defaultColumns: [
        'taskJobId',
        'executionDate',
        'currentStatus',
        'task',
        'currentJobStatus.createdByContactName',
        'currentJobStatus.reason.content',
        'attachment'
      ],
      columnTypings: [
        ...taskExecutionsDefault.columnTypings.filter(typing => typing.key !== 'task'),
        {
          key: 'task',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'taskId',
          displayKey: 'title',
          service: OrgaPortalFeatureTaskService,
          link: (task: TaskDto) => task?.taskId ? `/tasks/${ task.taskId }` : null,
          module: 'communication',
          permissions: [AppPermissions.ReadTask],
          linkPermissions: [AppPermissions.ReadTask],
          filters$: of([
            {
              property: 'parentId',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: null
            },
            {
              type: FilterTypes.Grouped,
              combinedAs: CombineOperator.And,
              children: [
                {
                  property: 'state',
                  type: FilterTypes.DataTransferObject,
                  operator: FilterOperators.NotEqual,
                  value: '3'
                },
                {
                  property: 'state',
                  type: FilterTypes.DataTransferObject,
                  operator: FilterOperators.NotEqual,
                  value: '2'
                }
              ]
            }
          ] as Filter[]),
        },
        {
          key: 'currentJobStatus.createdByContactName',
          type: DatatableTableColumnType.TEXT,
          name: 'created-by-user-name'
        },
        {
          key: 'currentJobStatus.reason.content',
          type: DatatableTableColumnType.TEXT,
          name: 'reason'
        }
      ]
    },

    /* Devices */
    DeviceDefault: {
      excludedColumns: [
        'location.locationNumber',
        'location.externalId',

        'contact.externalId',
        'contact.contactId',
        'contact.displayName'
      ],
      defaultColumns: [
        'id',
        'name',
        'location',
        'contact',
        'client',
        'version',
        'platform',
        'lastModified'
      ],
      columnTypings: [
        {
          key: 'id',
          type: DatatableTableColumnType.NUMBER,
          name: 'device-id'
        },
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationDto) => location ? `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'contact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact: ContactSimpleDto) => contact ? `/masterdata/contacts/${ contact.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact]
        },
        {
          key: 'client',
          type: DatatableTableColumnType.ENUM,
          enumOptions: clientOptions
        },
        {
          key: 'status',
          type: DatatableTableColumnType.ENUM,
          enumOptions: deviceStatusEnumOptions
        },
        {
          key: 'version',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          name: 'createdAt',
          utc: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'location.phonenumber',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'platform',
          type: DatatableTableColumnType.ENUM,
          enumOptions: platformEnumOptions
        }
      ]
    },
    PingDefault: {
      excludedColumns: [],
      defaultColumns: [
        'pingId',
        'sendAt',
        'arrivedAt',
        'appVersion'
      ],
      columnTypings: [
        {
          key: 'sendAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'arrivedAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        }
      ]
    }
  };
}

function provideCommunicationDatatableConfig(): CorePortalDatatableStandardConfig {
  const issueDefault: any = {
    excludedColumns: [
      'tenantId',
      'contactEmailAddress',
      'customPropertyValues',

      'createdByUserId',

      'stereotypeId',
      'stereotypeRowVersion',

      'location.locationId',
      'location.locationNumber',
      'location.externalId',
      'location.name',

      'issueTemplate.issueTemplateId',
      'issueTemplate.name',
      'issueTemplate.externalId',
      'issueTemplate.contentType',
      'issueTemplate.userMode',

      'issue',
      'issue.issueId',
      'issue.issueType',
      'issue.tenantId',
      'issue.stereotype',

      'issue.location.locationId',
      'issue.location.name',
      'issue.location.locationNumber',
      'issue.location.externalId',

      'issue.resource.resourceId',
      'issue.resource.name',
      'issue.resource.inventoryNumberCount',
      'issue.resource.inventoryNumber',
      'issue.resource.locationId',
      'issue.resource.parentId',
      'issue.resource.location.locationId',
      'issue.resource.location.name',
      'issue.resource.location.locationNumber',
      'issue.resource.location.externalId',
      'issue.resource.stereotype',
      'issue.resource.stereotype.stereotypeId',
      'issue.resource.stereotype.name',
      'issue.resource.stereotype.position',
      'issue.resource.stereotype.tenantId',
      'issue.resource.stereotype.rowVersion',
      'issue.resource.stereotype.emoji',
      'issue.resource.stereotype.isArchived',
      'issue.resource.stereotype.externalId',
      'issue.resource.externalId',
      'issue.resource.isArchived',
      'issue.resource.path',
      'issue.resource.location',

      'priority.priorityId',
      'priority.name',
      'priority.tenantId',
      'priority.isArchived',

      'stereotype.name',
      'stereotype.tenantId',
      'stereotype.emoji',
      'stereotype.rowVersion',
      'stereotype.position',
      'stereotype.isArchived',
      'stereotype.externalId',
      'stereotype.stereotypeId',

      'resource.resourceId',
      'resource.name',
      'resource.inventoryNumberCount',
      'resource.inventoryNumber',
      'resource.locationId',
      'resource.parentId',
      'resource.location',
      'resource.location.name',
      'resource.stereotype',
      'resource.externalId',
      'resource.isArchived',
      'resource.path',
      'resource.stereotype.name',
      'resource.stereotype.emoji',
      'resource.stereotype.stereotypeId',
      'resource.stereotype.position',
      'resource.stereotype.tenantId',
      'resource.stereotype.rowVersion',
      'resource.stereotype.isArchived',
      'resource.stereotype.externalId',

      'control.controlId',
      'control.title',

      'reason',
      'reason.type',
      'reason.type',
      'reason.frequency',
      'reason.errorCode.errorCodeId',
      'reason.errorCode.externalId',
      'reason.errorCode.displayName',
      'reason.consumptionCode.consumptionCodeId',
      'reason.consumptionCode.externalId',
      'reason.consumptionCode.displayName',
      'reason.consumptionCode.unit',
      'reason.triggerValue',
      'reason.triggerType',
      'reason.lowerLimit',
      'reason.upperLimit',
      'reason.limit',
      'reason.errorCode',
      'reason.consumptionCode'
    ],
    defaultColumns: [
      'issueId',
      'title'
    ],
    columnTypings: [
      {
        key: 'issueId',
        type: DatatableTableColumnType.NUMBER,
        name: 'id'
      },
      {
        key: 'labelRelations',
        displayKey: 'label.cluster',
        type: DatatableTableColumnType.ARRAY,
        disableSorting: true
      },
      {
        key: 'title',
        type: DatatableTableColumnType.TEXT,
        notificationCountKey: 'unreadNotificationCount'
      },
      {
        key: 'issue.title',
        type: DatatableTableColumnType.TEXT,
        name: 'title'
      },
      {
        key: 'createdByName',
        type: DatatableTableColumnType.TEXT,
        name: 'createdByUserName'
      },
      {
        key: 'createdAt',
        type: DatatableTableColumnType.DATE,
        name: 'createdAt',
        utc: true
      },
      {
        key: 'contactFirstName',
        type: DatatableTableColumnType.TEXT,
        name: 'firstName'
      },
      {
        key: 'contactLastName',
        type: DatatableTableColumnType.TEXT,
        name: 'lastName'
      },
      {
        key: 'issueType',
        type: DatatableTableColumnType.ENUM,
        enumOptions: issueTypeEnumOptions
      },
      {
        key: 'stereotype',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'stereotypeId',
        displayKey: 'name',
        name: 'stereotype',
        service: CorePortalStereotypeService,
        filters$: of([{
          property: 'entityType',
          type: FilterTypes.DataTransferObject,
          operator: FilterOperators.Equal,
          value: AppEntityType.Issue.toString()
        }] as Filter[]),
        link: (value: StereotypeSimpleDto) => value ? `/stereotypes/${ value.stereotypeId }` : null,
        module: 'settings',
        permissions: [AppPermissions.ReadStereotype],
        linkPermissions: [AppPermissions.DisplayStereoTypes]
      },
      {
        key: 'issueTemplate',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'issueTemplateId',
        displayKey: 'name',
        name: 'issueTemplate',
        service: TechPortalIssueTemplateService,
        link: (value: IssueTemplateDto) => value ? `/issues/${ value.issueTemplateId }` : null,
        module: 'settings',
        permissions: [AppPermissions.ReadIssueTemplate],
        linkPermissions: [AppPermissions.DisplayIssueTemplates]
      },
      {
        key: 'control',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'controlId',
        displayKey: 'title',
        name: 'control',
        service: TechPortalFeatureControlService,
        link: (value: ControlSimpleDto) => value ? `/controls/${ value.controlId }` : null,
        module: 'inventory',
        permissions: [AppPermissions.ReadControl],
        linkPermissions: [AppPermissions.DisplayControls]
      },
      {
        key: 'issue.createdByName',
        type: DatatableTableColumnType.TEXT,
        name: 'createdByUserName'
      },
      {
        key: 'resource',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'resourceId',
        name: 'resource',
        displayKey: 'name',
        service: CorePortalFeatureResourceService,
        link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
        module: 'inventory',
        permissions: [AppPermissions.ReadResource],
        linkPermissions: [AppPermissions.ReadResource]
      },
      {
        key: 'location',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'locationId',
        displayKey: 'name',
        name: 'location',
        service: CorePortalFeatureMasterDataLocationService,
        link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
        module: 'management',
        permissions: [AppPermissions.ReadLocation],
        linkPermissions: [AppPermissions.ReadLocation]
      },
      {
        key: 'issue.resource',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'resourceId',
        name: 'resource',
        displayKey: 'name',
        service: CorePortalFeatureResourceService,
        link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
        module: 'inventory',
        permissions: [AppPermissions.ReadResource],
        linkPermissions: [AppPermissions.ReadResource]
      },
      {
        key: 'issue.location',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'locationId',
        displayKey: 'name',
        name: 'location',
        service: CorePortalFeatureMasterDataLocationService,
        link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
        module: 'management',
        permissions: [AppPermissions.ReadLocation],
        linkPermissions: [AppPermissions.ReadLocation]
      },
      {
        key: 'issue.createdAt',
        type: DatatableTableColumnType.DATE,
        name: 'createdAt',
        utc: true
      },
      {
        key: 'issue.lastModified',
        type: DatatableTableColumnType.DATE,
        name: 'lastModified',
        utc: true
      },
      {
        key: 'unreadNotificationCount',
        type: DatatableTableColumnType.NUMBER,
        name: 'unreadNotificationCount'
      },
      {
        key: 'lastNotificationOccurredAt',
        type: DatatableTableColumnType.DATE,
        name: 'lastNotification',
        utc: true
      }
    ]
  }

  const infoMembershipDefault: any = {
    excludedColumns: [
      'location.externalId', 'contact.contactId', 'contact.externalId', 'location.locationNumber',
    ],
    defaultColumns: [
      'contact',
      'createdAt'
    ],
    columnTypings: [
      {
        key: 'contact',
        type: DatatableTableColumnType.REFERENCE,
        idKey: 'contactId',
        displayKey: 'displayName',
        service: CorePortalContactService,
        link: (contact: ContactSimpleDto) => contact?.contactId ?
          `/masterdata/contacts/${ contact.contactId }` : null,
        module: 'management',
        permissions: [AppPermissions.ReadContact],
        linkPermissions: [AppPermissions.ReadContact],
        alternate: {
          idKey: 'functionId',
          displayKey: 'name',
          service: CorePortalFunctionService
        }
      },
      {
        key: 'createdAt',
        type: DatatableTableColumnType.DATE,
        utc: true
      },
      {
        key: 'location.phonenumber',
        type: DatatableTableColumnType.PHONE
      },
    ]
  };

  return {
    /* Tickets */
    TicketDefault: {
      excludedColumns: [
        'customPropertyValues',
        'stereotypeId',
        'tenantId',
        'stereotypeRowVersion',
        'rowVersion',
        'isArchived',
        'currentStateId',
        'escalationLevelId',
        'resourceId',

        'editor.stereotypeId',
        'editor.stereotype.emoji',
        'editor.stereotypeRowVersion',
        'editor.customPropertyValues',
        'editor.position',
        'editor.contactId',
        'editor.user',
        'editor.user.id',
        'editor.stereotype.stereotypeId',
        'editor.stereotype.name',
        'editor.stereotype.isArchived',
        'editor.stereotype.tenantId',
        'editor.stereotype.rowVersion',
        'editor.stereotype.position',
        'editor.stereotype.externalId',

        'resource.stereotype.externalId',
        'resource.resourceId',
        'resource.name',
        'resource.path',
        'resource.pathJson',
        'resource.tenantId',
        'resource.rowVersion',
        'resource.stereotypeId',
        'resource.stereotypeRowVersion',
        'resource.customPropertyValues',
        'resource.stereotype.tenantId',
        'resource.stereotype.emoji',
        'resource.stereotype.rowVersion',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.name',
        'resource.stereotype.isArchived',
        'resource.stereotype.position',

        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.emoji',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'stereotype.name',

        'currentState.tenantId',
        'currentState.rowVersion',
        'currentState.stereotypeId',
        'currentState.stereotypeRowVersion',
        'currentState.stateId',
        'currentState.name',
        'currentState.color',

        'priority.tenantId',
        'priority.priorityId',
        'priority.name',
        'priority.isArchived',

        'escalationLevel.tenantId',
        'escalationLevel.escalationLevelId',
        'escalationLevel.name',
        'currentState.externalId',

        'location.tenantId',
        'location.state',
        'location.phoneNumber',
        'location.locationNumber',
        'location.externalId',
        'location.rowVersion',
        'location.stereotypeId',
        'location.stereotypeRowVersion',
        'location.stereotype.stereotypeId',
        'location.stereotype.emoji',
        'location.stereotype.position',
        'location.stereotype.tenantId',
        'location.stereotype.rowVersion',
        'location.stereotype.isArchived',
        'location.stereotype.externalId',
        'location.customPropertyValues',

        'location.shippingAddress.addressId',

        'location.invoiceAddress.addressId',
      ],
      defaultColumns: [
        'ticketId',
        'title',
        'escalationLevel',
        'currentState',
        'editor',
        'labels',
        'stereotype',
        'priority',
        'resource'
      ],
      columnTypings: [
        {
          key: 'title',
          type: DatatableTableColumnType.TEXT,
          name: 'title',
          prependIcon: {
            icon: faExclamation,
            color: () => GlobalStateColor.Red,
            size: '1x',
            margin: 2,
            show: (value: TicketDto) => value?.priority?.isCritical ?? false
          }
        },
        {
          key: 'description',
          type: DatatableTableColumnType.TEXT,
          maxHeight: 300
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'locationNumber',
          type: DatatableTableColumnType.TEXT,
          fixedWidth: 160
        },

        // Escalation level
        {
          key: 'escalationLevel',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'escalationLevelId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsEscalationLevelService,
          link: (escalationLevel: EscalationLevelSimpleDto) => escalationLevel ?
            `/escalation-levels/${ escalationLevel.escalationLevelId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadEscalationLevel],
          linkPermissions: [AppPermissions.ReadEscalationLevel]
        },

        // Current state
        {
          key: 'currentState',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stateId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsStateService,
          prependIcon: {
            color: (value: StateDto) => value?.color,
            icon: faCircle,
            size: 'xs'
          },
          permissions: [AppPermissions.ReadState]
        },
        {
          key: 'currentState.color',
          type: DatatableTableColumnType.TEXT,
          prependIcon: {
            color: (value: StateDto) => value?.color,
            icon: faCircle,
            size: 'xs'
          }
        },

        // Priority
        {
          key: 'priority',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'priorityId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsPriorityService,
          permissions: [AppPermissions.ReadPriority]
        },
        {
          key: 'priority.isArchived',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'priority.isCritical',
          name: 'isCritical',
          type: DatatableTableColumnType.BOOLEAN
        },

        // Resource
        {
          key: 'resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (resource: ResourceInTicketDto) => resource?.resourceId ? `/resources/${ resource.resourceId }` : null,
          module: 'inventory',
          fragment: 'edit',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'resource.isArchived',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'location.invoiceAddress',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          name: 'invoice-address',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },
        {
          key: 'location.shippingAddress',
          name: 'shipping-address',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },
        {
          key: 'location.phonenumber',
          type: DatatableTableColumnType.PHONE
        },

        // Editor
        {
          key: 'editor',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (editor: ContactSimpleDto) => editor ? `/masterdata/contacts/${ editor.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact],
          alternate: {
            idKey: 'functionId',
            displayKey: 'name',
            service: CorePortalFunctionService
          }
        },
        {
          key: 'editor.mobile',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'editor.phone',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'labelRelations',
          displayKey: 'label.cluster',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'resource.type',
          name: 'resource-type',
          type: DatatableTableColumnType.ENUM,
          enumOptions: resourceTypeEnumOptions
        },
        {
          key: 'resource.currentState',
          name: 'resource-state',
          type: DatatableTableColumnType.ENUM,
          prependIcon: {
            color: (value: any) => resourceStateEnumOptions[value?.resource?.currentState - 1].color,
            icon: faCircle,
            size: 'xs'
          },
          enumOptions: resourceStateEnumOptions
        },
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation],
          alternate: {
            idKey: 'locationGroupId',
            displayKey: 'name',
            service: CorePortalFeatureMasterDataLocationGroupService
          }
        }
      ]
    },

    /* Infos */
    InfoDefault: {
      excludedColumns: [
        'attachments',
        'answerEnabled',
        'tenantId',
        'sender',
        'sender.tenantId',
        'sender.rowVersion',
        'sender.stereotypeRowVersion',
        'sender.stereotypeId',
        'sender.isArchived',
        'sender.name',
        'sender.functionId',
        'sender.externalId',
        'content'
      ],
      defaultColumns: [
        'infoId',
        'title',
        'categoryRelations',
        'state',
        'dateTime',
        'requestRead'
      ],
      columnTypings: [
        {
          key: 'dateTime',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'requestRead',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'read-status-required'
        },
        {
          key: 'isRead',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'is-read'
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'isExpired',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'expiryDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'expires-in'
        },
        {
          key: 'readAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'read-when'
        },
        {
          key: 'contentAsText',
          type: DatatableTableColumnType.TEXT,
          name: 'content'
        },
        {
          key: 'state',
          type: DatatableTableColumnType.ENUM,
          name: 'current-state',
          enumOptions: infoStateEnumOptions,
          prependIcon: {
            color: (value: InfoDto) => infoStateEnumOptions[value?.state - 1]?.color,
            colorProp: 'state',
            icon: faCircle,
            size: 'xs'
          }
        },

        // Categories
        {
          key: 'categoryRelations',
          name: 'categories',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'categoryId',
          displayKey: 'name',
          multiple: true,
          mapValues: (values: CategorizedRelationDto[]) => values.map(x => x.category),
          service: CoreSharedCategoryService,
          filterProp: 'categoryRelations',
          filters$: of([
            {
              property: 'feature',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Contains,
              value: CategorizedType.Info.toString()
            },
            {
              property: 'sector',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: CategorySector.Everywhere.toString()
            }
          ]),
          labelTitleTemplateKey: 'categoryLabelTitleTemplate',
          optionTitleTemplateKey: 'categoryOptionTitleTemplate',
          permissions: [AppPermissions.ReadCategory]
        }
      ]
    },

    // InfoProgress
    InfoProgressFunctionsDefault: {
      excludedColumns: [
        'name',
        'function.tenantId',
        'function.functionId',
        'function.name',
        'function.externalId',
        'function.stereotypeId',
        'function.isArchived',
        'function.rowVersion',
        'function.stereotypeRowVersion',
        'expectedReaderCount'
      ],
      defaultColumns: [
        'functionId',
        'function',
        'currentReaderCount'
      ],
      columnTypings: [
        {
          key: 'function',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'functionId',
          name: 'name',
          displayKey: 'name',
          service: CorePortalFunctionService,
          link: (f: FunctionSimpleDto) => f?.functionId ?
            `/masterdata/functions/${ f?.functionId }` : null,
          module: 'management',
          clickable: true
        },
        {
          key: 'functionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id',
          clickable: true
        },
        {
          key: 'currentReaderCount',
          type: DatatableTableColumnType.PROGRESSBAR,
          totalKey: 'expectedReaderCount',
          clickable: true
        }
      ]
    },
    InfoProgressLocationsDefault: {
      excludedColumns: [
        'name',
        'location.locationId',
        'location.name',
        'location.locationNumber',
        'location.externalId'
      ],
      defaultColumns: [
        'locationId',
        'location',
        'currentReaderCount'
      ],
      columnTypings: [
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          name: 'name',
          displayKey: 'name',
          service: CorePortalLocationService,
          link: (location) => location?.locationId ?
            `/masterdata/locations/${ location?.locationId }` : null,
          module: 'management',
          clickable: true
        },
        {
          key: 'locationId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id',
          clickable: true
        },
        {
          key: 'currentReaderCount',
          type: DatatableTableColumnType.PROGRESSBAR,
          totalKey: 'expectedReaderCount',
          clickable: true
        }
      ]
    },
    InfoProgressContactsDefault: {
      excludedColumns: [
        'name',
        'contact.contactId',
        'contact.displayName',
        'contact.externalId',
        'readLocation.locationId',
        'readLocation.locationNumber',
        'readLocation.externalId',
        'readLocation.name',
      ],
      defaultColumns: [
        'contactId',
        'contact',
        'isExpected',
        'readWhen',
        'readLocation',
        'functions',
        'locations',
      ],
      columnTypings: [
        {
          key: 'contact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          name: 'name',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact) => contact?.contactId ?
            `/masterdata/contacts/${ contact?.contactId }` : null,
          module: 'management'
        },
        {
          key: 'contactId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'isExpected',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'expected'
        },
        {
          key: 'readWhen',
          type: DatatableTableColumnType.DATE,
          name: 'read-at',
          utc: true
        },
        {
          key: 'locations',
          displayKey: 'name',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'functions',
          displayKey: 'name',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'readLocation',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        }
      ]
    },

    // KnowledgePathsProgress
    KnowledgePathsProgressFunctionsDefault: {
      excludedColumns: [
        'name',
        'function.tenantId',
        'function.functionId',
        'function.name',
        'function.externalId',
        'function.stereotypeId',
        'function.isArchived',
        'function.rowVersion',
        'function.stereotypeRowVersion',
        'expectedReaderCount'
      ],
      defaultColumns: [
        'functionId',
        'function',
        'currentReaderCount'
      ],
      columnTypings: [
        {
          key: 'function',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'functionId',
          name: 'name',
          displayKey: 'name',
          service: CorePortalFunctionService,
          link: (f: FunctionSimpleDto) => f?.functionId ?
            `/masterdata/functions/${ f?.functionId }` : null,
          module: 'management',
          clickable: true
        },
        {
          key: 'functionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id',
          clickable: true
        },
        {
          key: 'currentReaderCount',
          type: DatatableTableColumnType.PROGRESSBAR,
          totalKey: 'expectedReaderCount',
          clickable: true
        }
      ]
    },
    KnowledgePathsProgressLocationsDefault: {
      excludedColumns: [
        'name',
        'location.locationId',
        'location.name',
        'location.locationNumber',
        'location.externalId'
      ],
      defaultColumns: [
        'locationId',
        'location',
        'currentReaderCount'
      ],
      columnTypings: [
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          name: 'name',
          displayKey: 'name',
          service: CorePortalLocationService,
          link: (location) => location?.locationId ?
            `/masterdata/locations/${ location?.locationId }` : null,
          module: 'management',
          clickable: true
        },
        {
          key: 'locationId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id',
          clickable: true
        },
        {
          key: 'currentReaderCount',
          type: DatatableTableColumnType.PROGRESSBAR,
          totalKey: 'expectedReaderCount',
          clickable: true
        }
      ]
    },
    KnowledgePathsProgressContactsDefault: {
      excludedColumns: [
        'name',
        'contact.contactId',
        'contact.displayName',
        'contact.externalId',
        'readLocation.locationId',
        'readLocation.locationNumber',
        'readLocation.externalId',
        'readLocation.name',

        'certificate.fileId',
        'certificate.tenantId',
        'certificate.path',
        'certificate.hash',
        'certificate.creationDateTime',
        'certificate.mimeType',
        'certificate.size',
        'certificate.uri',
      ],
      defaultColumns: [
        'contactId',
        'contact',
        'isExpected',
        'status',
        'score',
        'readWhen',
        'readLocation',
        'completedWhen',
        'functions',
        'locations',
        'certificate.name',
      ],
      columnTypings: [
        {
          key: 'contact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          name: 'name',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact) => contact?.contactId ?
            `/masterdata/contacts/${ contact?.contactId }` : null,
          module: 'management'
        },
        {
          key: 'contactId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'isExpected',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'expected'
        },
        {
          key: 'isCompleted',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'isCompleted'
        },
        {
          key: 'status',
          type: DatatableTableColumnType.ENUM,
          enumOptions: knowledgePathProgressStatusEnumOptions,
          name: 'status'
        },
        {
          key: 'completedWhen',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'score',
          type: DatatableTableColumnType.NUMBER,
          name: 'averageScore'
        },
        {
          key: 'certificate.name',
          type: DatatableTableColumnType.LINK,
          clickable: true,
          name: 'certificate'
        },
        {
          key: 'readWhen',
          type: DatatableTableColumnType.DATE,
          name: 'read-at',
          utc: true
        },
        {
          key: 'locations',
          displayKey: 'name',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'functions',
          displayKey: 'name',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'readLocation',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        }
      ]
    },

    /* Knowledge Article */
    KnowledgeArticleDefault: {
      excludedColumns: [
        'tenantId',
        'oldKnowledgePathId'
      ],
      defaultColumns: [
        'knowledgeArticleId',
        'title',
        'tags'
      ],
      columnTypings: []
    },

    /* Knowledge Path */
    KnowledgePathDefault: {
      excludedColumns: [
        'tenantId',
        'locations',
        'locationGroups'
      ],
      defaultColumns: [
        'knowledgePathId',
        'title',
        'categoryRelations'
      ],
      columnTypings: [
        // Categories
        {
          key: 'categoryRelations',
          name: 'categories',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'categoryId',
          displayKey: 'name',
          multiple: true,
          mapValues: (values: CategorizedRelationDto[]) => values.map(x => x.category),
          service: CoreSharedCategoryService,
          filterProp: 'categoryRelations',
          filters$: of([
            {
              property: 'feature',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Contains,
              value: CategorizedType.KnowledgePath.toString()
            },
            {
              property: 'sector',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: CategorySector.Everywhere.toString()
            }
          ]),
          labelTitleTemplateKey: 'categoryLabelTitleTemplate',
          optionTitleTemplateKey: 'categoryOptionTitleTemplate',
          permissions: [AppPermissions.ReadCategory]
        }
      ]
    },

    /* Knowledge Exam */
    KnowledgeExamDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'knowledgeExamId',
        'title'
      ],
      columnTypings: [
        // {
        //   key: 'knowledgeExamId',
        //   type: DatatableTableColumnType.REFERENCE,
        //   idKey: 'knowledgeExamId',
        //   name: 'id',
        //   displayKey: 'id',
        //   service: CorePortalContactService,
        //   link: (contact) => contact?.contactId ?
        //     `/masterdata/contacts/${contact?.contactId}` : null,
        //   module: 'management'
        // },
        {
          key: 'knowledgeExamId',
          type: DatatableTableColumnType.TEXT,
          name: 'id'
        },
      ]
    },

    /* Issues */
    IssueDefault: issueDefault,

    ConnectedIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'issueType'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
      ],
      columnTypings: [
        ...issueDefault.columnTypings
      ]
    },

    MessageIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'issueType'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
      ],
      columnTypings: [
        ...issueDefault.columnTypings
      ]
    },

    MessageControlIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'issueType'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
        'control'
      ],
      columnTypings: [
        ...issueDefault.columnTypings
      ]
    },

    DirectMessageIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'issueType'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title'
      ],
      columnTypings: [
        ...issueDefault.columnTypings
      ]
    },

    MissionIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'mission.missionId',
        'mission.type',
        'mission.title',
        'mission.tenantId',
        'issueType'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
        'mission',
        'mission.state'
      ],
      columnTypings: [
        ...issueDefault.columnTypings,
        {
          key: 'mission.state',
          name: 'mission-state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: techPortalFeatureMissionStateEnumOptions,
          prependIcon: {
            color: (value: MissionIssueListDto) => techPortalFeatureMissionStateEnumOptions[value?.mission?.state]?.color,
            icon: faCircle,
            size: 'xs'
          },
          permissions: [AppPermissions.ReadMission]
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalFeatureMissionService,
          link: (mission: MissionSimpleListDto) => mission?.missionId ?
            `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        }
      ]
    },

    OrderIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'issueType',
        'assignedContact.contactId',
        'assignedContact.displayName',
        'assignedContact.externalId',
        'priority.isCritical',
        'locationReference',
        'articleReference',
        'issue.location',
        'issue.resource'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
      ],
      columnTypings: [
        ...issueDefault.columnTypings
      ]
    },

    TicketIssueDefault: {
      excludedColumns: [
        ...issueDefault.excludedColumns,
        'ticket.ticketId',
        'ticket.isArchived',
        'ticket.title',
        'ticket.state.stateId',
        'ticket.state.externalId',
        'ticket.state.tenantId',
        'ticket.state.name',
        'ticket.state.color',
        'issueType',
        'assignedContact.contactId',
        'assignedContact.displayName',
        'assignedContact.externalId',
        'priority.isCritical'
      ],
      defaultColumns: [
        ...issueDefault.defaultColumns,
        'issue.title',
        'ticket',
        'ticket.state',
      ],
      columnTypings: [
        ...issueDefault.columnTypings,
        {
          key: 'ticket.state',
          name: 'ticket-state',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stateId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsStateService,
          prependIcon: {
            color: (value: StateDto) => value?.color,
            icon: faCircle,
            size: 'xs'
          },
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadState]
        },
        {
          key: 'ticket',
          name: 'ticket',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'ticketId',
          displayKey: 'title',
          service: TechPortalTicketService,
          link: (value: TicketSimpleListDto) => value ? `/tickets/${ value.ticketId }` : null,
          module: 'communication',
          permissions: [AppPermissions.ReadTicket],
          linkPermissions: [AppPermissions.ReadTicket]
        },
        {
          key: 'issue.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          name: 'location',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'issue.resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          name: 'resource',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'priority',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'priorityId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsPriorityService,
          module: 'settings',
          permissions: [AppPermissions.ReadIssue, AppPermissions.ReadPriority]
        },
        {
          key: 'assignedContact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact) => contact?.contactId ? `/masterdata/contacts/${ contact?.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact]
        }
      ]
    },

    /* Tasks */
    TaskDefault: {
      excludedColumns: [
        'executionPlan.executionId',
        'tenantId',
        'executionPlan',
        'parentId',
        'isEnabled',
        'executionPlanId',
        'reasonSetId',
        'executionPlan.isManual',
        'executionPlan.isPlanned',
      ],
      defaultColumns: [
        'taskId',
        'title',
        'categoryRelations',
        'description',
        'type',
        'state',
        'executionPlan.type'
      ],
      columnTypings: [
        {
          key: 'type',
          type: DatatableTableColumnType.ENUM,
          name: 'entity-type',
          enumOptions: taskTypeEnumOptions
        },
        {
          key: 'state',
          type: DatatableTableColumnType.ENUM,
          name: 'current-state',
          prependIcon: {
            color: (value: any) => taskStatesEnumOptions[value?.state]?.color,
            colorProp: 'state',
            icon: faCircle,
            size: 'xs'
          },
          enumOptions: taskStatesEnumOptions
        },
        {
          key: 'executionPlan.type',
          type: DatatableTableColumnType.ENUM,
          name: 'execution-plan',
          enumOptions: executionPlanEnumOptions
        },
        {
          key: 'requiresAuthentication',
          type: DatatableTableColumnType.BOOLEAN
        },

        // Categories
        {
          key: 'categoryRelations',
          name: 'categories',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'categoryId',
          displayKey: 'name',
          multiple: true,
          mapValues: (values: CategorizedRelationDto[]) => values.map(x => x.category),
          service: CoreSharedCategoryService,
          filterProp: 'categoryRelations',
          filters$: of([
            {
              property: 'feature',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Contains,
              value: CategorizedType.Task.toString()
            },
            {
              property: 'sector',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: CategorySector.Everywhere.toString()
            }
          ]),
          labelTitleTemplateKey: 'categoryLabelTitleTemplate',
          optionTitleTemplateKey: 'categoryOptionTitleTemplate',
          permissions: [AppPermissions.ReadCategory]
        }
      ]
    },
    TaskExecutionArchiveDefault: {
      excludedColumns: [
        ...taskExecutionsDefault.excludedColumns,
        'currentJobStatus.createdByContactName',
        'generationKind'
      ],
      defaultColumns: [
        ...taskExecutionsDefault.defaultColumns,
        'finishDate',
        'editorName',
        'currentJobStatus.reason.content',
        'attachment',
        'children.attachment'
      ],
      columnTypings: [
        ...taskExecutionsDefault.columnTypings,
        {
          key: 'finishDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
        },
        {
          key: 'editorName',
          type: DatatableTableColumnType.TEXT,
          name: 'editor'
        },
        {
          key: 'currentJobStatus.reason.content',
          type: DatatableTableColumnType.TEXT,
          name: 'reason'
        }
      ]
    },
    TaskExecutionArchiveActive: {
      ...taskExecutionsDefault,
      excludedColumns: [
        ...taskExecutionsDefault.excludedColumns,
        'currentJobStatus.createdByContactName',
        'currentJobStatus.reason.content',
        'attachment',
        'generationKind',
        'finishDate'
      ]
    }
  };
}

function provideInventoryDatatableConfig(): CorePortalDatatableStandardConfig {
  return {
    /* Missions */
    MissionDefault: {
      excludedColumns: [
        'tenantId',
        'type',
        'solutionId',
        'ticketId',
        'stereotypeId',
        'stereotypeRowVersion',
        'customPropertyValues',
        'stereotype.name',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.emoji',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        "rowVersion",
        "links",
        "attachments",
        "isLabelingSince",
        "labels",
        "creator",
        "solution",
        "precursor",

        "isSendingMail",
        "lastEmailSend",
        "creator.id",
        "creator.name",
        "solution.solutionId",
        "solution.members",
        "solution.attachments",
        "solution.threadId",
        "solution.threadMailAddress",
        "reportId",

        "resource.stereotype.entityType",

        "precursor.missionId",
        "precursor.type",
        "precursor.title",
        "precursor.tenantId",

        "origin.primaryIssue.issueId",
        "origin.primaryIssue.title",
        "origin.primaryIssue.issueType",
        "origin.primaryIssue",

        'sourceTicket.stereotypeId',
        'sourceTicket.stereotypeRowVersion',
        'sourceTicket.stereotype.rowVersion',
        'sourceTicket.currentState.tenantId',
        'sourceTicket.currentState.stateId',
        'sourceTicket.currentState.name',
        'sourceTicket.currentState.color',
        'sourceTicket.editor.contactId',
        'sourceTicket.editor.user',
        'sourceTicket.editor.user.id',
        'sourceTicket.editor.stereotype.stereotypeId',
        'sourceTicket.editor.stereotype.name',
        'sourceTicket.editor.stereotype.isArchived',
        'sourceTicket.editor.stereotype.rowVersion',
        'sourceTicket.editor.stereotype.tenantId',
        'sourceTicket.editor.stereotypeId',
        'sourceTicket.editor.stereotypeRowVersion',
        'sourceTicket.editor.customPropertyValues',
        'sourceTicket.priority.tenantId',
        'sourceTicket.priority.priorityId',
        'sourceTicket.priority.name',
        'sourceTicket.priority.isArchived',
        'sourceTicket.priority.isCritical',
        'sourceTicket.resource.resourceId',
        'sourceTicket.resource.name',
        'sourceTicket.resource.inventoryNumber',
        'sourceTicket.resource.path',
        'sourceTicket.resource.pathJson',
        'sourceTicket.resource.stereotypeId',
        'sourceTicket.resource.stereotypeRowVersion',
        'sourceTicket.resource.stereotype.stereotypeId',
        'sourceTicket.resource.stereotype.name',
        'sourceTicket.resource.stereotype.emoji',
        'sourceTicket.resource.stereotype.isArchived',
        'sourceTicket.resource.stereotype.rowVersion',
        'sourceTicket.resource.stereotype.tenantId',
        'sourceTicket.resource.customPropertyValues',
        'sourceTicket.escalationLevel.escalationLevelId',
        'sourceTicket.escalationLevel.name',
        'sourceTicket.escalationLevel.tenantId',
        'sourceTicket.stereotype.stereotypeId',
        'sourceTicket.stereotype.name',
        'sourceTicket.stereotype.isArchived',
        'sourceTicket.stereotype.tenantId',
        'sourceTicket.customPropertyValues',
        'sourceTicket.resource.currentState',
        'sourceTicket.resource.type',
        "sourceTicket.resource.manufacturer",
        "sourceTicket.resource.model",
        "sourceTicket.resource.manufacturer.resourceManufacturerId",
        "sourceTicket.resource.manufacturer.name",
        "sourceTicket.resource.model.resourceModelId",
        "sourceTicket.resource.model.name",
        "sourceTicket.resource.model.resourceManufacturerId",

        'sourceTask.tenantId',
        'sourceTask.isArchived',
        'sourceTask.isCancelingObsoleteMissions',

        'sourceResource.pathJson',
        'sourceResource.path',
        'sourceResource.resourceId',
        'sourceResource.name',
        'sourceResource.tenantId',
        'sourceResource.stereotypeId',
        'sourceResource.stereotypeRowVersion',
        'sourceResource.customPropertyValues',
        'sourceResource.stereotype.stereotypeId',
        'sourceResource.stereotype.rowVersion',
        'sourceResource.stereotype.name',
        'sourceResource.stereotype.emoji',
        'sourceResource.stereotype.isArchived',
        'sourceResource.stereotype.tenantId',
        "sourceResource.manufacturer.resourceManufacturerId",
        "sourceResource.manufacturer.name",
        "sourceResource.model.resourceModelId",
        "sourceResource.model.name",
        "sourceResource.model.resourceManufacturerId",
        "sourceResource.manufacturer",
        "sourceResource.model",

        'solutionContact.user',
        'solutionContact.user.id',
        'solutionContact.stereotypeId',
        'solutionContact.stereotype.stereotypeId',
        'solutionContact.stereotype.name',
        'solutionContact.stereotype.emoji',
        'solutionContact.stereotype.tenantId',
        'solutionContact.stereotype.rowVersion',
        'solutionContact.stereotype.isArchived',
        'solutionContact.stereotypeRowVersion',
        'solutionContact.customPropertyValues',
        "solutionContact.email",
        "solutionContact.userId",

        'invoiceAddress.tenantId',
        'invoiceAddress.rowVersion',
        'invoiceAddress.stereotypeRowVersion',
        'invoiceAddress.customPropertyValues',
        'invoiceAddress.addressId',
        'invoiceAddress.stereotypeId',
        'invoiceAddress.stereotype.stereotypeId',
        'invoiceAddress.stereotype.name',
        'invoiceAddress.stereotype.tenantId',
        'invoiceAddress.stereotype.rowVersion',
        'invoiceAddress.stereotype.isArchived',
        'invoiceAddress.point',
        'invoiceAddress.point.lat',
        'invoiceAddress.point.lng',

        'shippingAddress.tenantId',
        'shippingAddress.rowVersion',
        'shippingAddress.stereotypeRowVersion',
        'shippingAddress.customPropertyValues',
        'shippingAddress.addressId',
        'shippingAddress.stereotypeId',
        'shippingAddress.stereotype.stereotypeId',
        'shippingAddress.stereotype.name',
        'shippingAddress.stereotype.tenantId',
        'shippingAddress.stereotype.rowVersion',
        'shippingAddress.stereotype.isArchived',
        'shippingAddress.point',
        'shippingAddress.point.lat',
        'shippingAddress.point.lng',

        'location.locationId',
        'location.tenantId',
        'location.state',
        'location.phoneNumber',
        'location.locationNumber',
        'location.externalId',
        'location.rowVersion',
        'location.stereotypeId',
        'location.stereotypeRowVersion',
        'location.stereotype.entityType',
        'location.stereotype.stereotypeId',
        'location.stereotype.position',
        'location.stereotype.emoji',
        'location.stereotype.tenantId',
        'location.stereotype.rowVersion',
        'location.stereotype.isArchived',
        'location.stereotype.externalId',
        'location.customPropertyValues',
        'location.info',
        'location.addresses',

        'location.shippingAddress.addressId',
        'location.shippingAddress.street',
        'location.shippingAddress.houseNumber',
        'location.shippingAddress.city',
        'location.shippingAddress.state',
        'location.shippingAddress.zipcode',
        'location.shippingAddress.countryCode',
        'location.shippingAddress.rowVersion',
        'location.shippingAddress.point.lat',
        'location.shippingAddress.point.lng',
        'location.shippingAddress.tenantId',
        "location.shippingAddress.point",

        'location.invoiceAddress.addressId',
        'location.invoiceAddress.street',
        'location.invoiceAddress.houseNumber',
        'location.invoiceAddress.city',
        'location.invoiceAddress.state',
        'location.invoiceAddress.zipcode',
        'location.invoiceAddress.countryCode',
        'location.invoiceAddress.point.lat',
        'location.invoiceAddress.point.lng',
        'location.invoiceAddress.tenantId',
        'location.invoiceAddress.rowVersion',
        "location.invoiceAddress.point",

        'report', // ToDo: Remove in the future
        'report.id',
        'report.missionReportId',
        'report.stereotypeId',
        'report.stereotypeRowVersion',
        'report.customPropertyValues',
        'report.stereotype', // ToDo: Remove in the future
        'report.stereotype.stereotypeId',
        'report.stereotype.name',
        'report.stereotype.tenantId',
        'report.stereotype.rowVersion',
        'report.stereotype.isArchived',

        'sourceTicket.resource.stereotype.position',
        'sourceTicket.resource.isArchived',
        'sourceTicket.stereotype.position',
        'sourceTicket.stereotype.emoji',
        'sourceTicket.editor.stereotype.position',
        'sourceTicket.isArchived',
        'solutionContact.stereotype.position',
        'shippingAddress.stereotype.position',
        'sourceResource.stereotype.position',
        'invoiceAddress.stereotype.position',
        'resource.stereotype.position',
        'editor.stereotype.position',
        'sourceTask.isActivated',

        'quest',
        'quest.function.functionId',
        'quest.function.tenantId',
        'quest.function.name',
        'quest.function.stereotypeId',
        'quest.function.isArchived',
        'quest.function.rowVersion',
        'quest.function.stereotypeRowVersion',

        'sourceResource.isArchived',

        'solutionContact.stereotype.externalId',
        'quest.function.externalId',
        'sourceTicket.currentState.externalId',
        'sourceTicket.editor.stereotype.externalId',
        'sourceTicket.editor.stereotype.emoji',
        'sourceTicket.resource.stereotype.externalId',
        'sourceTicket.stereotype.externalId',
        'sourceTicket.stereotype.emoji',
        'sourceResource.stereotype.externalId',
        'invoiceAddress.stereotype.externalId',
        'invoiceAddress.stereotype.emoji',
        'shippingAddress.stereotype.externalId',
        'shippingAddress.stereotype.emoji',
      ],
      defaultColumns: [
        'missionId',
        'title',
        'sourceResource',
        'plannedStart',
        'actualEnd',
        'state',
        'solutionContact',
        'stereotype'
      ],
      columnTypings: [
        {
          key: 'title',
          type: DatatableTableColumnType.TEXT,
          name: 'title',
          prependIcon: {
            icon: faExclamation,
            color: () => GlobalStateColor.Red,
            size: '1x',
            margin: 2,
            show: (value: MissionCompleteDto) => value?.isCritical
          }
        },
        {
          key: 'plannedStart',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'plannedEnd',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'actualStart',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'actualEnd',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'state',
          name: 'mission-state',
          type: DatatableTableColumnType.ENUM,
          prependIcon: {
            color: (value: any) => techPortalFeatureMissionStateEnumOptions[value?.state]?.color,
            colorProp: 'state',
            icon: faCircle,
            size: 'xs'
          },
          enumOptions: techPortalFeatureMissionStateEnumOptions
        },
        {
          key: 'locationNumber',
          type: DatatableTableColumnType.TEXT,
          fixedWidth: 160
        },
        {
          key: 'isCompleted',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'isOverdue',
          type: DatatableTableColumnType.BOOLEAN
        },

        // Source ticket
        {
          key: 'sourceTicket',
          name: 'ticket',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'ticketId',
          displayKey: 'title',
          service: TechPortalTicketService,
          link: (value: TicketSimpleDto) => value ? `/tickets/${ value.ticketId }` : null,
          module: 'communication',
          permissions: [AppPermissions.ReadTicket],
          linkPermissions: [AppPermissions.ReadTicket]
        },
        {
          key: 'isCritical',
          name: 'isCritical',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'sourceTicket.escalationLevel',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'escalationLevelId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsEscalationLevelService,
          link: (escalationLevel: EscalationLevelSimpleDto) => escalationLevel ?
            `/escalation-levels/${ escalationLevel.escalationLevelId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadEscalationLevel],
          linkPermissions: [AppPermissions.ReadEscalationLevel]
        },
        {
          key: 'sourceTicket.resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (resource: ResourceInTicketDto) => resource?.resourceId ? `/resources/${ resource.resourceId }` : null,
          module: 'inventory',
          fragment: 'edit',
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'sourceTicket.priority',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'priorityId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsPriorityService,
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadPriority]
        },
        {
          key: 'sourceTicket.currentState',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stateId',
          displayKey: 'name',
          service: TechPortalFeatureTicketSettingsStateService,
          prependIcon: {
            color: (value: StateDto) => value?.color,
            icon: faCircle,
            size: 'xs'
          },
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadState]
        },
        {
          key: 'sourceTicket.editor',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (editor: ContactSimpleDto) => editor ? `/masterdata/contacts/${ editor.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadTicket, AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact],
          alternate: {
            idKey: 'functionId',
            displayKey: 'name',
            service: CorePortalFunctionService
          }
        },
        {
          key: 'sourceTicket.editor.mobile',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'sourceTicket.editor.phone',
          type: DatatableTableColumnType.PHONE
        },

        // Source Task
        {
          key: 'sourceTask',
          name: 'resource-task',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceTaskId',
          displayKey: 'title',
          service: TechPortalFeatureResourceTaskService,
          link: (value: ResourceTaskSimpleDto) => value ? `/resource-tasks/${ value.resourceTaskId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResourceTask],
          linkPermissions: [AppPermissions.ReadResourceTask]
        },
        {
          key: 'sourceTask.isDeactivated',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'sourceTask.startDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'sourceTask.endDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },

        // Source Resource
        {
          key: 'sourceResource',
          name: 'resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'sourceResource.type',
          name: 'resource-type',
          type: DatatableTableColumnType.ENUM,
          enumOptions: resourceTypeEnumOptions
        },
        {
          key: 'sourceResource.currentState',
          name: 'resource-state',
          type: DatatableTableColumnType.ENUM,
          prependIcon: {
            color: (value: any) => value?.currentState?.color,
            icon: faCircle,
            size: 'xs'
          },
          enumOptions: resourceStateEnumOptions
        },
        {
          key: 'stateReason',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'location.invoiceAddress',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },
        {
          key: 'location.shippingAddress',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },

        // Solution contact
        {
          key: 'solutionContact',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (value: ContactSimpleDto) => value ? `/masterdata/contacts/${ value.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.DisplayContacts],
          alternate: {
            idKey: 'functionId',
            displayKey: 'name',
            service: CorePortalFunctionService
          }
        },

        {
          key: 'solutionContact.mobile',
          type: DatatableTableColumnType.PHONE
        },
        {
          key: 'solutionContact.phone',
          type: DatatableTableColumnType.PHONE
        },
        // Invoice address
        {
          key: 'invoiceAddress',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },

        // Shipping address
        {
          key: 'shippingAddress',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'addressId',
          displayKey: 'street',
          additionalSearchProperties: ['houseNumber', 'zipcode', 'city'],
          template: (address: AddressSimpleDto) => {
            if (address?.street) {
              let firstPart = address.street;
              let secondPart = address.city;

              if (address.houseNumber) {
                firstPart = `${ firstPart } ${ address.houseNumber }`;
              }

              if (address.zipcode) {
                secondPart = `${ address.zipcode } ${ secondPart }`;
              }

              return `${ firstPart }${ secondPart ? `, ${ secondPart }` : '' }`;
            }
          },
          service: CorePortalFeatureMasterDataAddressService,
          link: (value: AddressSimpleDto) => value ? `/masterdata/addresses/${ value.addressId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadAddress],
          linkPermissions: [AppPermissions.DisplayAddresses]
        },
        {
          key: 'quest.function',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'functionId',
          displayKey: 'name',
          service: CorePortalFunctionService
        },
        {
          key: 'quest.state',
          name: 'quest.state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: techPortalFeatureMissionQuestStateEnumOptions
        },
        {
          key: 'cost',
          disableFilter: true,
          type: DatatableTableColumnType.CURRENCY
        },
        {
          key: 'labelRelations',
          displayKey: 'label.cluster',
          type: DatatableTableColumnType.ARRAY,
          disableSorting: true
        },
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation],
          alternate: {
            idKey: 'locationGroupId',
            displayKey: 'name',
            service: CorePortalFeatureMasterDataLocationGroupService
          }
        },
        {
          key: 'stereotype',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stereotypeId',
          displayKey: 'name',
          service: CorePortalStereotypeService,
          filters$: of([{
            property: 'entityType',
            type: FilterTypes.DataTransferObject,
            operator: FilterOperators.Equal,
            value: AppEntityType.Mission.toString()
          }] as Filter[]),
          link: (value: StereotypeSimpleDto) => value ? `/stereotypes/${ value.stereotypeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadStereotype],
          linkPermissions: [AppPermissions.DisplayStereoTypes]
        },
      ]
    },

    /* Resources */
    ResourceDefault: {
      excludedColumns: [
        'customPropertyValues',
        'stereotypeId',
        'tenantId',
        'stereotypeRowVersion',
        'rowVersion',
        'locationId',
        'parentId',
        'externalParentId',
        'isInProgressSince',
        'pathJson',
        'stereotype.name',
        'stereotype.tenantId',
        'stereotype.emoji',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'inventoryNumberCount',
        'location.stereotype.name',
        'location.stereotype.stereotypeId',
        'location.stereotype.tenantId',
        'location.stereotype.rowVersion',
        'location.stereotype.isArchived',
        'location.addresses',
        'location.locationNumber',
        'location.stereotype.position',
        'location.stereotype.emoji',
        'location.stereotype.externalId',
        'locationGroup',
        'locationGroup.name',
        'locationGroup.locationGroupId',
        'locationGroup.externalId',
        'quickAccess',
        'quickAccessConfiguration.quickAccessConfigurationId',
        'quickAccessConfiguration',

        'manufacturer.resourceManufacturerId',
        'manufacturer.name',
        'model.resourceModelId',
        'model.name',
        'model.resourceManufacturerId',

        'latestStateEvent',
        'latestStateEvent.resourceEventId',
        'latestStateEvent.type',
        'latestStateEvent.tenantId',
        'latestStateEvent.lastModified',
        'latestStateEvent.oldLocation',
        'latestStateEvent.newLocation',
        'latestStateEvent.oldLocation.locationId',
        'latestStateEvent.oldLocation.name',
        'latestStateEvent.oldLocation.locationNumber',
        'latestStateEvent.oldLocation.externalId',
        'latestStateEvent.newLocation.locationId',
        'latestStateEvent.newLocation.name',
        'latestStateEvent.newLocation.locationNumber',
        'latestStateEvent.newLocation.externalId',

        'latestLocationEvent',
        'latestLocationEvent.resourceEventId',
        'latestLocationEvent.type',
        'latestLocationEvent.tenantId',
        'latestLocationEvent.lastModified',
        'latestLocationEvent.oldState',
        'latestLocationEvent.newState',
        'latestLocationEvent.oldLocation.locationId',
        'latestLocationEvent.oldLocation.name',
        'latestLocationEvent.oldLocation.locationNumber',
        'latestLocationEvent.oldLocation.externalId',
        'latestLocationEvent.newLocation.locationId',
        'latestLocationEvent.newLocation.name',
        'latestLocationEvent.newLocation.locationNumber',
        'latestLocationEvent.newLocation.externalId',
      ],
      defaultColumns: [
        'resourceId',
        'name',
        'location',
        'stereotype'
      ],
      columnTypings: [
        {
          key: 'hasChildren',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation],
          alternate: {
            idKey: 'locationGroupId',
            displayKey: 'name',
            service: CorePortalFeatureMasterDataLocationGroupService
          }
        },
        {
          key: 'installationDate',
          type: DatatableTableColumnType.DATE,
          format: 'LL',
          utc: true
        },
        {
          key: 'isArchived',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'path',
          type: DatatableTableColumnType.PATH,
          disableSorting: true
        },
        {
          key: 'latestStateEvent.createdAt',
          type: DatatableTableColumnType.DATE,
          format: 'LL',
          utc: true,
          name: 'latest-state-event-created-at'
        },
        {
          key: 'latestLocationEvent.createdAt',
          type: DatatableTableColumnType.DATE,
          format: 'LL',
          utc: true,
          name: 'latest-location-event-created-at'
        },
        {
          key: 'latestStateEvent.oldState',
          type: DatatableTableColumnType.ENUM,
          enumOptions: resourceStateEnumOptions,
          name: 'latest-event-old-state'
        },
        {
          key: 'latestStateEvent.newState',
          type: DatatableTableColumnType.ENUM,
          enumOptions: resourceStateEnumOptions,
          name: 'latest-event-new-state'
        },
        {
          key: 'latestLocationEvent.oldLocation',
          type: DatatableTableColumnType.REFERENCE,
          name: 'latest-event-old-location',
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleListDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation],
          alternate: {
            idKey: 'locationGroupId',
            displayKey: 'name',
            service: CorePortalFeatureMasterDataLocationGroupService
          }
        },
        {
          key: 'latestLocationEvent.newLocation',
          type: DatatableTableColumnType.REFERENCE,
          name: 'latest-event-new-location',
          idKey: 'locationId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleListDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation],
          alternate: {
            idKey: 'locationGroupId',
            displayKey: 'name',
            service: CorePortalFeatureMasterDataLocationGroupService
          }
        },
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'location.state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: locationStateEnumOptions
        },
        {
          key: 'location.stereotype',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stereotypeId',
          displayKey: 'name',
          service: CorePortalStereotypeService,
          filters$: of([{
            property: 'entityType',
            type: FilterTypes.DataTransferObject,
            operator: FilterOperators.Equal,
            value: AppEntityType.Location.toString()
          }] as Filter[]),
          link: (value: StereotypeSimpleDto) => value ? `/stereotypes/${ value.stereotypeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadStereotype],
          linkPermissions: [AppPermissions.DisplayStereoTypes]
        },
        {
          key: 'stereotype',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'stereotypeId',
          displayKey: 'name',
          service: CorePortalStereotypeService,
          filters$: of([{
            property: 'entityType',
            type: FilterTypes.DataTransferObject,
            operator: FilterOperators.Equal,
            value: AppEntityType.Resource.toString()
          }] as Filter[]),
          link: (value: StereotypeSimpleDto) => value ? `/stereotypes/${ value.stereotypeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadStereotype],
          linkPermissions: [AppPermissions.DisplayStereoTypes]
        },
        {
          key: 'quickAccess.link',
          type: DatatableTableColumnType.LINK,
        },
        {
          key: 'quickAccessConfiguration.isActivated',
          type: DatatableTableColumnType.BOOLEAN,
        },
        {
          key: 'type',
          name: 'resource-type',
          type: DatatableTableColumnType.ENUM,
          enumOptions: resourceTypeEnumOptions
        },
        {
          key: 'manufacturer',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceManufacturerId',
          displayKey: 'name',
          service: CorePortalManufacturerService,
          link: (value: ResourceManufacturerListDto) => value ? `/manufacturers/${ value.resourceManufacturerId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadResourceManufacturer],
          linkPermissions: [AppPermissions.DisplayResourceManufacturers]
        },
        {
          key: 'model',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceModelId',
          displayKey: 'name',
          service: CorePortalModelService,
          link: (value: ResourceModelListDto) => value ? `/manufacturers/${ (value as any).resourceManufacturerId }/model/${ value.resourceModelId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadResourceModel],
          linkPermissions: [AppPermissions.DisplayResourceManufacturers]
        },
        {
          key: 'locationGroup',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationGroupId',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationGroupService,
          mapValues: (locationGroups: LocationGroupRelationListDto[]) => locationGroups.map(x => x.locationGroup),
          filterProp: 'locationGroup',
          multiple: false,
          separator: ', '
        },
        {
          key: 'currentState',
          name: 'resource-state',
          type: DatatableTableColumnType.ENUM,
          prependIcon: {
            color: (value: ResourceDto) => resourceStateEnumOptions[value.currentState - 1].color,
            colorProp: 'currentState',
            icon: faCircle,
            size: 'xs'
          },
          enumOptions: resourceStateEnumOptions
        },
      ]
    },

    /* Articles */
    ArticleDefault: {
      excludedColumns: [
        'id',
        'stereotypeRowVersion',
        'tenantId',
        'stereotypeId',
        'customPropertyValues',

        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',

        'kind.articleKindId',
        'kind.name'
      ],
      defaultColumns: [
        'name',
        'number',
        'stereotype'
      ],
      columnTypings: [
        {
          key: 'number',
          name: 'article-number',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'purchasingPrice',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'sellingPrice',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'kind',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'articleKindId',
          displayKey: 'name',
          service: CorePortalFeatureArticleKindService,
          permissions: [AppPermissions.ReadArticleKind]
        }
      ]
    },

    /* Article Usages */
    ArticleUsagesDefault: {
      excludedColumns: [
        'id',
        'mission.missionId',
        'mission.title',
        'mission.plannedStart',
        'mission.plannedEnd',
        'mission.actualStart',
        'mission.actualEnd',
        'mission.type',
        'mission.resource.inventoryNumber',
        'mission.resource.resourceId',
        'mission.resource.name',
        'mission.resource.location.name',
        'mission.resource.location.locationNumber',
        'mission.resource',
        'mission.resource.location',
        'mission.resource.location.locationId',
      ],
      defaultColumns: [
        'articleUsageId',
        'mission',
        'price',
        'count',
        'total',
        'note'
      ],
      columnTypings: [
        {
          key: 'articleUsageId',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'count',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'price',
          type: DatatableTableColumnType.CURRENCY,
          name: 'single-price'

        },
        {
          key: 'total',
          type: DatatableTableColumnType.CURRENCY,
          name: 'total-amount'
        },
        {
          key: 'note',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        }
      ]
    },

    /* Controls */
    ControlDefault: {
      excludedColumns: [
        'tenantId',
        'isArchived'
      ],
      defaultColumns: [
        'controlId',
        'title',
        'condition',
        'isActivated',
      ],
      columnTypings: [
        {
          key: 'controlId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'condition',
          type: DatatableTableColumnType.ENUM,
          name: 'condition',
          enumOptions: controlConditionTypeEnumOptions
        },
        {
          key: 'isActivated',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'startDate',
          name: 'actual-start',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'endDate',
          name: 'actual-end',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
      ]
    },

    /* Control Issues */
    ControlIssueDefault: {
      excludedColumns: [
        'issueType',
        'issue',
        'issue.tenantId',
        'issue.issueId',
        'issue.locationId',
        'issue.issueType',
        'issue.location.name',
        'issue.location.locationNumber',
        'issue.location.externalId',
        'issue.location.locationId',

        'issue.resource.name',
        'issue.resource.resourceId',
        'issue.resource.inventoryNumberCount',
        'issue.resource.inventoryNumber',
        'issue.resource.locationId',
        'issue.resource.parentId',
        'issue.resource.location.locationId',
        'issue.resource.location.name',
        'issue.resource.location.locationNumber',
        'issue.resource.location.externalId',
        'issue.resource.stereotype.stereotypeId',
        'issue.resource.stereotype',
        'issue.resource.stereotype.name',
        'issue.resource.stereotype.position',
        'issue.resource.stereotype.emoji',
        'issue.resource.stereotype.tenantId',
        'issue.resource.stereotype.rowVersion',
        'issue.resource.stereotype.isArchived',
        'issue.resource.stereotype.externalId',
        'issue.resource.externalId',
        'issue.resource.isArchived',
        'issue.resource.path',
        'issue.resource.location',
        'issue.resource.stereotype',
        'issue.lastModified',
        'issue.createdByName',
        'issue.lastModified',

        'control.controlId',
        'control.title',

        'reason',
        'reason.triggerType',
        'reason.errorCode.errorCodeId',
        'reason.errorCode.externalId',
        'reason.errorCode.displayName',
        'reason.consumptionCode.consumptionCodeId',
        'reason.consumptionCode.externalId',
        'reason.consumptionCode.displayName',
        'reason.consumptionCode.unit',
      ],
      defaultColumns: [
        'issueId',
        'issue.title',
        'issue.location',
        'issue.resource',
        'issue.createdAt',
        'reason.triggerValue'
      ],
      columnTypings: [
        {
          key: 'issue.issueId',
          type: DatatableTableColumnType.TEXT,
          name: 'id'
        },
        {
          key: 'issue.title',
          type: DatatableTableColumnType.TEXT,
          name: 'title'
        },
        {
          key: 'issue.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          name: 'location',
          service: CorePortalFeatureMasterDataLocationService,
          link: (value: LocationSimpleDto) => value ? `/masterdata/locations/${ value.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'issue.resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          name: 'resource',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'reason.type',
          name: 'reason',
          type: DatatableTableColumnType.ENUM,
          enumOptions: controlIssueReasonTypeEnumOptions
        },
        {
          key: 'control',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'controlId',
          displayKey: 'title',
          name: 'control',
          service: TechPortalFeatureControlService,
          link: (value: ControlSimpleDto) => value ? `/controls/${ value.controlId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadControl],
          linkPermissions: [AppPermissions.DisplayControls]
        },
        {
          key: 'issue.createdAt',
          name: 'created-at',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'reason.triggerValue',
          name: 'trigger',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'reason.frequency',
          name: 'frequency',
          type: DatatableTableColumnType.TIME
        },
        {
          key: 'reason.lowerLimit',
          name: 'lower-limit',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'reason.upperLimit',
          name: 'upper-limit',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'reason.limit',
          name: 'limit',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'reason.consumptionCode',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-consumption',
          idKey: 'consumptionCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedConsumptionCodeService,
          link: (consumption: ConsumptionCodeSimpleListDto) => consumption?.consumptionCodeId ? `/connected/${ consumption.consumptionCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedConsumption],
          linkPermissions: [AppPermissions.ReadOccurredConnectedConsumption]
        },
        {
          key: 'reason.errorCode',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-error',
          idKey: 'errorCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedErrorCodeService,
          link: (error: ErrorCodeSimpleListDto) => error?.errorCodeId ? `/connected/${ error.errorCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedError],
          linkPermissions: [AppPermissions.ReadOccurredConnectedError]
        }
      ]
    },

    /* Resource Tasks */
    ResourceTaskDefault: {
      excludedColumns: [
        'tenantId',
        'isCancelingObsoleteMissions',
        'isArchived'
      ],
      defaultColumns: [
        'resourceTaskId',
        'title',
        'startDate',
        'endDate',
        'isActivated'
      ],
      columnTypings: [
        {
          key: 'startDate',
          name: 'actual-start',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'endDate',
          name: 'actual-end',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'startOffSet',
          name: 'start-offset',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'timeOfDay',
          name: 'execution-time',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'isActivated',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    /* Contracts */
    ContractDefault: {
      excludedColumns: [
        'rowVersion',
        'customPropertyValues',
        'stereotypeId',
        'stereotypeRowVersion',
        'tenantId',
        'duePeriod',

        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.position',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.stereotypeId',
        'stereotype.name',
        'stereotype.emoji',
      ],
      defaultColumns: [
        'contractId',
        'title',
        'description',
        'state'
      ],
      columnTypings: [
        {
          key: 'state',
          name: 'current-state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: contractStateEnumOptions,
          prependIcon: {
            color: (value: ContractDto) => contractStateEnumOptions[value?.state]?.color,
            colorProp: 'state',
            icon: faCircle,
            size: 'xs'
          }
        },
        {
          key: 'startDate',
          name: 'actual-start',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'endDate',
          name: 'actual-end',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'dueDate',
          type: DatatableTableColumnType.DATE,
          utc: true
        }
      ]
    },
    /* My Requests */
    MyRequestsDefault: {
      excludedColumns: [
        'mission.missionId',
        'mission.title',
        'mission.type',
        'mission.tenantId',
        'contactId'
      ],
      defaultColumns: [
        'missionId',
        'mission',
        'createdAt'
      ],
      columnTypings: [
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'missionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'mission-id'
        },
        {
          key: 'mission.isArchived',
          type: DatatableTableColumnType.BOOLEAN,
        },
        {
          key: 'mission.state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: techPortalFeatureMissionStateEnumOptions,
          name: 'status'
        },
        {
          key: 'mission.plannedStart',
          name: 'plannedStart',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'mission.plannedEnd',
          name: 'plannedEnd',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        },
      ]
    },
    /* Mission Reports List */
    ReportsListDefault: {
      excludedColumns: [
        'mission.missionId',
        'mission.type',
        'mission.tenantId',
        'mission.lastModified',
        'mission.description',
        'mission.solutionId',
        'mission.solutionContact.displayName',
        'mission.solutionContact.contactId',
        'mission.solutionContact.firstName',
        'mission.solutionContact.lastName',
        'mission.solutionContact.emailAddress',
        'mission.solutionContact.user',
        'mission.solutionContact.user.email',
        'mission.solutionContact.user.id',
        'mission.solutionContact.phone',
        'mission.solutionContact.mobile',
        'mission.solutionContact.stereotype',
        'mission.solutionContact.stereotype.stereotypeId',
        'mission.solutionContact.stereotypeId',
        'mission.solutionContact.stereotypeRowVersion',
        'mission.solutionContact.stereotype.name',
        'mission.solutionContact.stereotype.position',
        'mission.solutionContact.stereotype.tenantId',
        'mission.resource.resourceId',
        'mission.resource.name',
        'mission.resource.inventoryNumberCount',
        'mission.resource.inventoryNumber',
        'mission.resource.locationId',
        'mission.resource.path',
        'mission.resource.isArchived',
        'mission.resource.location',
        'mission.resource.parentId',
        'mission.resource.stereotype',
        'mission.resource.externalId',
        'mission.resource.location.locationId',
        'mission.resource.location.name',
        'mission.resource.location.locationNumber',
        'mission.resource.location.externalId',
        'mission.resource.stereotype.stereotypeId',
        'mission.resource.stereotype.name',
        'mission.resource.stereotype.position',
        'mission.resource.stereotype.emoji',
        'mission.resource.stereotype.tenantId',
        'mission.resource.stereotype.rowVersion',
        'mission.resource.stereotype.isArchived',
        'mission.resource.stereotype.externalId',
        'mission.location.locationId',
        'mission.location.name',
        'mission.location.locationNumber',
        'mission.location.externalId',
        'mission.solutionContact.stereotype.rowVersion',
        'mission.solutionContact.stereotype.isArchived',
        'mission.solutionContact.stereotype.emoji',
        'mission.solutionContact.stereotype.externalId',
        'mission.resource.resourceId',
        'mission.resource.name',
        'mission.resource.inventoryNumberCount',
        'mission.resource.inventoryNumber',
        'mission.resource.locationId',
        'mission.resource.path',
        'mission.resource.isArchived',
        'mission.resource.location',
        'mission.resource.parentId',
        'mission.resource.stereotype',
        'mission.resource.externalId',
        'mission.resource.location.locationId',
        'mission.resource.location.name',
        'mission.resource.location.locationNumber',
        'mission.resource.location.externalId',
        'mission.resource.stereotype.stereotypeId',
        'mission.resource.stereotype.name',
        'mission.resource.stereotype.position',
        'mission.resource.stereotype.tenantId',
        'mission.resource.stereotype.rowVersion',
        'mission.resource.stereotype.isArchived',
        'mission.resource.stereotype.externalId',
        'mission.location.locationId',
        'mission.location.name',
        'mission.location.locationNumber',
        'mission.location.externalId',
        'stereotypeId',
        'stereotypeRowVersion',
        'stereotype.stereotypeId',
        'stereotype.position',
        'stereotype.name',
        'stereotype.emoji',
        'stereotype.tenantId',
        'stereotype.rowVersion',
        'stereotype.isArchived',
        'stereotype.externalId',
        'customPropertyValues',
        'contactId',
        'travelCosts',
        'workCosts',
        'groups'
      ],
      defaultColumns: [
        'missionReportId',
        'mission',
        'usedArticles'
      ],
      columnTypings: [
        {
          key: 'missionReportId',
          type: DatatableTableColumnType.TEXT,
          clickable: true,
          name: 'id'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        },
        {
          key: 'total',
          type: DatatableTableColumnType.CURRENCY,
          name: 'total'
        },
        {
          key: 'mission.isArchived',
          type: DatatableTableColumnType.BOOLEAN,
        },
        {
          key: 'mission.title',
          name: 'mission-title',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'usedArticles',
          name: 'articles',
          type: DatatableTableColumnType.ARRAY,
          displayKey: 'article.name',
          disableSorting: true
        },
        {
          key: 'mission.actualStart',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'actualStart'
        },
        {
          key: 'mission.actualEnd',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'actualEnd'
        },
        {
          key: 'mission.plannedStart',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'plannedStart'
        },
        {
          key: 'mission.plannedEnd',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'plannedEnd'
        },
        {
          key: 'mission.createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'createdAt'
        },
        {
          key: 'mission.state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: techPortalFeatureMissionStateEnumOptions,
          name: 'status'
        },
        {
          key: 'mission.isCompleted',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'isCompleted'
        },
        {
          key: 'mission.solutionContact',
          type: DatatableTableColumnType.REFERENCE,
          name: 'editor',
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact: ContactInMissionListDto) => contact?.contactId ? `/masterdata/contacts/${ contact.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact]
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        },
        {
          key: 'mission.resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          name: 'resource',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'mission.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          name: 'location',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationSimpleDto) => location?.locationId ?
            `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        }
      ]
    },
    /* Mission Receipts List */
    ReceiptsListDefault: {
      excludedColumns: [
        'mission.missionId',
        'mission.type',
        'mission.tenantId',
        'mission.lastModified',
        'mission.description',
        'mission.solutionId',
        'mission.solutionContact.displayName',
        'mission.solutionContact.contactId',
        'mission.solutionContact.firstName',
        'mission.solutionContact.lastName',
        'mission.solutionContact.emailAddress',
        'mission.solutionContact.user',
        'mission.solutionContact.user.email',
        'mission.solutionContact.user.id',
        'mission.solutionContact.phone',
        'mission.solutionContact.mobile',
        'mission.solutionContact.stereotype',
        'mission.solutionContact.stereotype.stereotypeId',
        'mission.solutionContact.stereotypeId',
        'mission.solutionContact.stereotypeRowVersion',
        'mission.solutionContact.stereotype.name',
        'mission.solutionContact.stereotype.position',
        'mission.solutionContact.stereotype.tenantId',
        'mission.resource.resourceId',
        'mission.resource.name',
        'mission.resource.inventoryNumberCount',
        'mission.resource.inventoryNumber',
        'mission.resource.locationId',
        'mission.resource.path',
        'mission.resource.isArchived',
        'mission.resource.location',
        'mission.resource.parentId',
        'mission.resource.stereotype',
        'mission.resource.externalId',
        'mission.resource.location.locationId',
        'mission.resource.location.name',
        'mission.resource.location.locationNumber',
        'mission.resource.location.externalId',
        'mission.resource.stereotype.stereotypeId',
        'mission.resource.stereotype.name',
        'mission.resource.stereotype.position',
        'mission.resource.stereotype.emoji',
        'mission.resource.stereotype.tenantId',
        'mission.resource.stereotype.rowVersion',
        'mission.resource.stereotype.isArchived',
        'mission.resource.stereotype.externalId',
        'mission.location.locationId',
        'mission.location.name',
        'mission.location.locationNumber',
        'mission.location.externalId',
        'mission.solutionContact.stereotype.rowVersion',
        'mission.solutionContact.stereotype.isArchived',
        'mission.solutionContact.stereotype.emoji',
        'mission.solutionContact.stereotype.externalId',
        'externalId'
      ],
      defaultColumns: [
        'missionReceiptId',
        'title',
        'mission',
        'invoiceNumber',
        'bookedAt',
        'debit',
        'credit',
        'taxInPercent'
      ],
      columnTypings: [
        {
          key: 'missionReceiptId',
          type: DatatableTableColumnType.TEXT,
          name: 'id'
        },
        {
          key: 'bookedAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'booked-at'
        },
        {
          key: 'debit',
          type: DatatableTableColumnType.CURRENCY
        },
        {
          key: 'credit',
          type: DatatableTableColumnType.CURRENCY
        },
        {
          key: 'taxInPercent',
          type: DatatableTableColumnType.TEXT,
          name: 'tax'
        },
        {
          key: 'mission.isArchived',
          type: DatatableTableColumnType.BOOLEAN,
        },
        {
          key: 'mission.title',
          name: 'mission-title',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'mission.actualStart',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'actualStart'
        },
        {
          key: 'mission.actualEnd',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'actualEnd'
        },
        {
          key: 'mission.plannedStart',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'plannedStart'
        },
        {
          key: 'mission.plannedEnd',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'plannedEnd'
        },
        {
          key: 'mission.createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          name: 'createdAt'
        },
        {
          key: 'mission.state',
          type: DatatableTableColumnType.ENUM,
          enumOptions: techPortalFeatureMissionStateEnumOptions,
          name: 'status'
        },
        {
          key: 'mission.isCompleted',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'isCompleted'
        },
        {
          key: 'mission.solutionContact',
          type: DatatableTableColumnType.REFERENCE,
          name: 'editor',
          idKey: 'contactId',
          displayKey: 'displayName',
          service: CorePortalContactService,
          link: (contact: ContactInMissionListDto) => contact?.contactId ? `/masterdata/contacts/${ contact.contactId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadContact],
          linkPermissions: [AppPermissions.ReadContact]
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        },
        {
          key: 'mission.resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          name: 'resource',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (value: ResourceSimpleDto) => value ? `/resources/${ value.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'mission.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          name: 'location',
          displayKey: 'name',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationSimpleDto) => location?.locationId ?
            `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        }
      ]
    }
  };
}

function provideServiceDatatableConfig(): CorePortalDatatableStandardConfig {
  return {
    /* Tenants */
    ServiceTenantDefault: {
      excludedColumns: [],
      defaultColumns: [
        'tenantId',
        'displayName',
        'domain',
        'productSubscriptions',
        'isActive',
        'brand',
        'internalCustomNumber',
        'nextDemoExpirationDate'
      ],
      columnTypings: [
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'nextDemoExpirationDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL',
        },
        {
          key: 'productSubscriptions',
          type: DatatableTableColumnType.ENUM,
          filterProp: 'edition',
          multiple: true,
          disableSorting: true,
          enumOptions: tenantSubscriptionTypeEnumOptions,
          mapValues: (values: ProductSubscriptionDto[]) =>
            values
              .map(x => x.edition)
              // Avoid duplicates
              .filter((edition, index, self) =>
                index === self.findIndex(e => e === edition)
              )
        }
      ]
    },
    ServiceTenantSubscriptionDefault: {
      excludedColumns: [],
      defaultColumns: [
        'productSubscriptionId',
        'edition',
        'kind',
        'amount',
        'dealCode',
        'expiresIn',
        'createdAt'
      ],
      columnTypings: [
        {
          key: 'edition',
          type: DatatableTableColumnType.ENUM,
          name: 'edition',
          enumOptions: tenantSubscriptionTypeEnumOptions
        },
        {
          key: 'kind',
          type: DatatableTableColumnType.ENUM,
          enumOptions: tenantSubscriptionKindOptions
        },
        {
          key: 'startDate',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL'
        },
        {
          key: 'note',
          type: DatatableTableColumnType.TEXT,
          name: 'public-note'
        },
        {
          key: 'expiresIn',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'LL',
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true
        }
      ]
    },
    WageListDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'wageListId',
        'name',
        'travelCost',
        'workDurationCost',
        'travelCalculationMode',
      ],
      columnTypings: [
        {
          key: 'wageListId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'travelCost',
          type: DatatableTableColumnType.CURRENCY,
          name: 'travelDurationCost',
        },
        {
          key: 'workDurationCost',
          type: DatatableTableColumnType.CURRENCY,
        },
        {
          key: 'travelCalculationMode',
          type: DatatableTableColumnType.ENUM,
          enumOptions: wageListTravelCalculationModeEnumOptions
        }
      ]
    },
    ServiceTenantSystemContactDefault: {
      excludedColumns: [],
      defaultColumns: [
        'contactId',
        'displayName',
        'emailAddress',
        'firstName',
        'lastName'
      ],
      columnTypings: []
    },
    ServicePatchNotesDefault: {
      excludedColumns: [],
      defaultColumns: [
        'patchNoteId',
        'title',
        'brand',
        'client',
        'version',
      ],
      columnTypings: [
        {
          key: 'patchNoteId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'title',
          type: DatatableTableColumnType.TEXT,
          name: 'title'
        },
        {
          key: 'brand',
          type: DatatableTableColumnType.ENUM,
          enumOptions: brandOptions
        },
        {
          key: 'client',
          type: DatatableTableColumnType.ENUM,
          enumOptions: clientOptions
        },
        {
          key: 'version',
          type: DatatableTableColumnType.TEXT
        },
      ]
    },
  };
}

function provideSettingsDatatableConfig(): CorePortalDatatableStandardConfig {
  return {
    /* Categories */
    CategoryDefault: {
      excludedColumns: [
        'color',
        'emoji',
        'feature',
      ],
      defaultColumns: [
        'categoryId',
        'name',
        'sector'
      ],
      columnTypings: [
        {
          key: 'sector',
          name: 'display',
          type: DatatableTableColumnType.ENUM,
          enumOptions: categorySectorEnumOptions
        }
      ]
    },

    /* Labels */
    LabelsDefault: {
      excludedColumns: [
        'id'
      ],
      defaultColumns: [
        'content'
      ],
      columnTypings: [
        {
          key: 'id',
          name: 'id',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'content',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'cluster',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Invitations */
    InvitationsDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'invitationId',
        'name',
        'code',
        'purpose',
        'isRevoked',
        'createdAt'
      ],
      columnTypings: [
        {
          key: 'invitationId',
          name: 'id',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'name',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'code',
          name: 'invitation-code',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'purpose',
          type: DatatableTableColumnType.ENUM,
          enumOptions: invitationPurposeEnumOptions
        },
        {
          key: 'isRevoked',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        }
      ]
    },

    /* Settings Release Monitors */
    SettingsReleaseMonitorsDefault: {
      excludedColumns: [],
      defaultColumns: [
        'releaseMonitorId',
        'name',
        'erpType'
      ],
      columnTypings: [
        {
          key: 'releaseMonitorId',
          name: 'id',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'name',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'erpType',
          type: DatatableTableColumnType.ENUM,
          enumOptions: releaseMonitorErpTypesEnumOptions
        },
        {
          key: 'trigger',
          type: DatatableTableColumnType.ENUM,
          enumOptions: releaseMonitorErpTriggerReasonsEnumOptions
        }
      ]
    },

    /* Settings Release Monitors */
    SettingsReleaseMonitorsEntriesDefault: {
      excludedColumns: [
        'missionId',
        'mission.missionId',
        'mission.type',
        'mission.title',
        'mission.tenantId',
        'error',
        'error.member',
        'error.parameters',
        'error.code',
        'lexwareEntryBody',
        'lexwareEntryBody.lexwareEntryBodyId',
        'lexwareEntryBody.releaseEntryId'
      ],
      defaultColumns: [
        'releaseEntryId',
        'status',
        'mission',
        'lexwareEntryBody.deeplink'
      ],
      columnTypings: [
        {
          key: 'releaseEntryId',
          name: 'id',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'releaseMonitorId',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'error.description',
          type: DatatableTableColumnType.TEXT,
          name: 'error'
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'lexwareEntryBody.deeplink',
          type: DatatableTableColumnType.LINK,
          name: 'link'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'status',
          type: DatatableTableColumnType.ENUM,
          name: 'status',
          enumOptions: releaseEntryStatusTypesEnumOptions
        },
        {
          key: 'mission',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'missionId',
          displayKey: 'title',
          service: TechPortalMissionService,
          link: (mission: MissionDto) => mission?.missionId ? `/missions/all/${ mission.missionId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadMission],
          linkPermissions: [AppPermissions.ReadMission]
        }
      ]
    },

    /* Ticket Settings */
    SettingsTicketSettingsStateDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion',
        'kind'
      ],
      defaultColumns: [
        'stateId',
        'name',
        'color'
      ],
      columnTypings: [
        {
          key: 'color',
          type: DatatableTableColumnType.TEXT,
          prependIcon: {
            icon: faCircle,
            color: (value: StateDto) => value?.color,
            size: 'xs'
          }
        }
      ]
    },
    NotificationRulesDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'notificationRuleId',
        'title'
      ],
      columnTypings: []
    },
    SettingsTicketSettingsStateMachineDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion'
      ],
      defaultColumns: [
        'stateMachineId',
        'name'
      ],
      columnTypings: []
    },
    SettingsTicketSettingsPrioritySetDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion',
        'id'
      ],
      defaultColumns: [
        'prioritySetId',
        'name'
      ],
      columnTypings: []
    },
    SettingsTicketSettingsEscalationLevelDefault: {
      excludedColumns: [
        'tenantId',
        'id'
      ],
      defaultColumns: [
        'escalationLevelId',
        'name'
      ],
      columnTypings: []
    },
    SettingsTicketSettingsProcessDefault: {
      excludedColumns: [],
      defaultColumns: [
        'ticketByProcessDefinitionId',
        'name'
      ],
      columnTypings: []
    },

    /* Dashboards */
    SettingsDashboardDefault: {
      excludedColumns: [
        'tenantId',
        'rowVersion'
      ],
      defaultColumns: [
        'dashboardId',
        'name'
      ],
      columnTypings: []
    },

    AppOverviewDefault: {
      excludedColumns: [],
      defaultColumns: [
        'appOverviewId',
        'title'
      ],
      columnTypings: []
    },

    /* Cancellation Reasons */
    CancellationReasonsDefault: {
      excludedColumns: [],
      defaultColumns: [
        'taskJobStateReasonSetId',
        'title'
      ],
      columnTypings: []
    },

    /* Forms */
    FormDefault: {
      excludedColumns: [],
      defaultColumns: [
        'formId',
        'title',
        'description'
      ],
      columnTypings: [
        {
          key: 'isArchived',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    /* Chat Definitions */
    ChatDefinitionDefault: {
      excludedColumns: [],
      defaultColumns: [
        'chatByFormDefinitionId',
        'title'
      ],
      columnTypings: []
    },

    /* Mail Nodes */
    SettingsMailNodeDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'mailNodeId',
        'title'
      ],
      columnTypings: []
    },

    /* Mass Import */
    SettingsImportProtocolDefault: {
      excludedColumns: [
        'tenantId',
        'importConfigurationId',
        'importContentBlobPath'
      ],
      defaultColumns: [
        'importProtocolId',
        'title',
        'createdAt',
        'isColdRun',
        'status',
      ],
      columnTypings: [
        {
          key: 'importProtocolId',
          type: DatatableTableColumnType.TEXT,
          name: 'id'
        },
        {
          key: 'title',
          type: DatatableTableColumnType.TEXT,
          name: 'xml-title'
        },
        {
          key: 'isColdRun',
          type: DatatableTableColumnType.BOOLEAN,
          name: 'is-cold-run'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'status',
          type: DatatableTableColumnType.ENUM,
          name: 'status',
          enumOptions: importProtocolStatusEnumOptions
        },
        {
          key: 'importContentBlobPath',
          type: DatatableTableColumnType.LINK,
          name: 'import-content-blob-path'
        }
      ]
    },

    /* Import Configuration */
    SettingsImportConfigurationsDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'importConfigurationId',
        'title',
      ],
      columnTypings: [
        {
          key: 'importConfigurationId',
          type: DatatableTableColumnType.TEXT,
          name: 'id',
          clickable: true
        },
        {
          key: 'title',
          type: DatatableTableColumnType.TEXT,
          name: 'title',
          clickable: true
        },
      ]
    },

    /* Searchlists */
    SettingsSearchListsDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'searchListId',
        'title'
      ],
      columnTypings: []
    },

    /* Text Templates */
    TemplatesTextDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'templateId',
        'title',
        'context'
      ],
      columnTypings: [
        {
          key: 'context',
          type: DatatableTableColumnType.ENUM,
          enumOptions: textContextTypeEnumOptions.map(enumOption => ({
            ...enumOption,
            label: enumOption.readonlyLabel ?? enumOption.label
          }))
        }
      ]
    },
    TemplatesDocumentDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'documentTemplateId',
        'title',
        'contextType',
        'isDefault'
      ],
      columnTypings: [
        {
          key: 'contextType',
          name: 'context',
          type: DatatableTableColumnType.ENUM,
          enumOptions: documentContextTypeEnumOptions.map(enumOption => ({
            ...enumOption,
            label: enumOption.readonlyLabel ?? enumOption.label
          }))
        },
        {
          key: 'isDefault',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    SettingsTicketsByLocationDefinitionDefault: {
      excludedColumns: [
        'stereotype',
        'tenantId',
        'stereotype.stereotypeId',
        'stereotype.position',
        'stereotype.tenantId',
        'stereotype.emoji',
        'stereotype.isArchived',
        'stereotype.externalId',
        'stereotype.rowVersion'
      ],
      defaultColumns: [
        'ticketsByLocationDefinitionId',
        'title'
      ],
      columnTypings: [
        {
          key: 'ticketsByLocationDefinitionId',
          name: 'id',
          type: DatatableTableColumnType.NUMBER
        }
      ]
    },

    SettingsResourcesByLocationDefinitionDefault: {
      excludedColumns: [
        'stereotype',
        'tenantId',
        'stereotype.stereotypeId',
        'stereotype.position',
        'stereotype.tenantId',
        'stereotype.emoji',
        'stereotype.rowVersion',
        'stereotype.isArchived',
        'stereotype.externalId'
      ],
      defaultColumns: [
        'resourcesByLocationDefinitionId',
        'title'
      ],
      columnTypings: [
        {
          key: 'resourcesByLocationDefinitionId',
          name: 'id',
          type: DatatableTableColumnType.NUMBER
        }
      ]
    },

    /* Inventory number patterns */
    SettingsInventoryNumberPatternDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'inventoryNumberPatternId',
        'title'
      ],
      columnTypings: []
    },

    /* Reserved inventory number */
    SettingsInventoryNumberReservationsDefault: {
      excludedColumns: [
        'tenantId',
        'key',
        'inventoryNumber',
        'inventoryNumber.count',
        'inventoryNumber.prefix',
        'inventoryNumber.suffix',
        'inventoryNumber.inventoryNumberId'
      ],
      defaultColumns: [
        'reservedInventoryNumberId',
        'name',
        'number',
        'link',
      ],
      columnTypings: [
        {
          key: 'reservedInventoryNumberId',
          type: DatatableTableColumnType.TEXT,
          name: 'id'
        },
        {
          key: 'number',
          type: DatatableTableColumnType.TEXT,
          name: 'inventory-number'
        },
        {
          key: 'link',
          type: DatatableTableColumnType.LINK,
          name: 'link'
        },
      ]
    },

    /* Mail logs */
    SettingsMailLogsDefault: {
      excludedColumns: [
        'tenantId',
        'error',
        'error.member',
        'error.parameters',
        'sender',
        'sender.tenantId',
        'sender.status',
        'sender.id',
        'sender.type',
        'sender.statusReason',
        'sender.statusCreatedAt',

        'payload',
        'payload.fileId',
        'payload.tenantId',
        'payload.path',
        'payload.hash',
        'payload.creationDateTime',
        'payload.name',
        'payload.mimeType',
        'payload.size',
        'payload.uri',
      ],
      defaultColumns: [
        'id',
        'receivers',
        'subject',
        'createdAt',
        'error.description'
      ],
      columnTypings: [
        {
          key: 'id',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'receivers',
          type: DatatableTableColumnType.HTML,
          disableSorting: true,
          filterProp: 'receivers.address'
        },
        {
          key: 'error.description',
          type: DatatableTableColumnType.TEXT,
          name: 'error'
        },
        {
          key: 'sender.address',
          type: DatatableTableColumnType.TEXT,
          name: 'emailAddress'
        },
        {
          key: 'createdAt',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'isSPFValid',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'sender.address',
          type: DatatableTableColumnType.TEXT,
          name: 'address'
        },
        {
          key: 'isSpam',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'spamScore',
          type: DatatableTableColumnType.NUMBER,
        },
        {
          key: 'error.code',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'direction',
          type: DatatableTableColumnType.ENUM,
          enumOptions: noteDirectionOptions
        },
        {
          key: 'mailInStatus',
          type: DatatableTableColumnType.ENUM,
          enumOptions: mailInStatusTypeEnumOptions
        },
      ]
    },

    /* Manufacturer Settings */
    SettingsManufacturerDefault: {
      excludedColumns: [],
      defaultColumns: [
        'resourceManufacturerId',
        'name'
      ],
      columnTypings: [
        {
          key: 'resourceManufacturerId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        }
      ]
    },

    /* Manufacturer Model Settings */
    SettingsModelDefault: {
      excludedColumns: [],
      defaultColumns: [
        'resourceModelId',
        'name'
      ],
      columnTypings: [
        {
          key: 'resourceModelId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        }
      ]
    },

    /* Timeline Settings */
    SettingsTimelineDefault: {
      excludedColumns: [],
      defaultColumns: [
        'timelineSettingId',
        'isInstructedMissionsOnly',
        'stereotypes',
        'locationGroups',
        'locations'
      ],
      columnTypings: [
        {
          key: 'timelineSettingId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'isInstructedMissionsOnly',
          type: DatatableTableColumnType.BOOLEAN,
        },
        {
          key: 'stereotypes',
          type: DatatableTableColumnType.ARRAY,
          displayKey: 'name',
          disableSorting: true
        },
        {
          key: 'locationGroups',
          type: DatatableTableColumnType.ARRAY,
          displayKey: 'name',
          disableSorting: true
        },
        {
          key: 'locations',
          type: DatatableTableColumnType.ARRAY,
          displayKey: 'name',
          disableSorting: true
        }
      ]
    },

    /* Issue templates */
    SettingsIssueDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'issueTemplateId',
        'name',
        'contentType',
        'externalId'
      ],
      columnTypings: [
        {
          key: 'issueTemplateId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'contentType',
          type: DatatableTableColumnType.ENUM,
          enumOptions: issueContentTypeEnumOptions
        },
        // Categories
        {
          key: 'categoryRelations',
          name: 'categories',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'categoryId',
          displayKey: 'name',
          multiple: true,
          mapValues: (values: CategorizedRelationDto[]) => values.map(x => x.category),
          service: CoreSharedCategoryService,
          filterProp: 'categoryRelations',
          filters$: of([
            {
              property: 'feature',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Contains,
              value: CategorizedType.IssueTemplate.toString()
            },
            {
              property: 'sector',
              type: FilterTypes.DataTransferObject,
              operator: FilterOperators.Equal,
              value: CategorySector.Everywhere.toString()
            }
          ]),
          labelTitleTemplateKey: 'categoryLabelTitleTemplate',
          optionTitleTemplateKey: 'categoryOptionTitleTemplate',
          permissions: [AppPermissions.ReadCategory]
        }
      ]
    },

    /* Consumption Codes */
    ConsumptionCodeDefault: {
      excludedColumns: [],
      defaultColumns: [
        'consumptionCodeId',
        'displayName',
        'unit'
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Error Codes */
    ErrorCodeDefault: {
      excludedColumns: [],
      defaultColumns: [
        'errorCodeId',
        'displayName'
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Hint Codes */
    HintCodeDefault: {
      excludedColumns: [],
      defaultColumns: [
        'hintCodeId',
        'displayName'
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Definitions */
    ConnectedDefinitionDefault: {
      excludedColumns: [],
      defaultColumns: [
        'connectedDefinitionId',
        'displayName',
      ],
      columnTypings: [
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Resource Occurred Consumptions */
    ResourceOccurredConsumptionsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'consumption',
        'consumption.externalId',
        'consumption.consumptionCodeId',
      ],
      defaultColumns: [
        'consumptionCodeId',
        'displayName',
        'lastModified',
        'value'
      ],
      columnTypings: [
        {
          key: 'consumptionCodeId',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'occurredConsumptionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'displayName',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        }
      ]
    },

    /* Resource Occurred Errors */
    ResourceOccurredErrorsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'error.errorCodeId',
        'error.externalId',
        'error'
      ],
      defaultColumns: [
        'occurredErrorId',
        'displayName',
        'lastModified',
        'isActive'
      ],
      columnTypings: [
        {
          key: 'occurredErrorId',
          type: DatatableTableColumnType.NUMBER,
          addIfNotAvailable: true
        },
        {
          key: 'errorCodeId',
          type: DatatableTableColumnType.NUMBER,
          addIfNotAvailable: true
        },
        {
          key: 'displayName',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },
    /* Resource Occurred Errors */
    ResourceOccurredHintsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.position',
        'resource.stereotype.emoji',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'hint.hintCodeId',
        'hint.externalId',
        'hint'
      ],
      defaultColumns: [
        'occurredHintId',
        'displayName',
        'lastModified',
        'isActive'
      ],
      columnTypings: [
        {
          key: 'occurredHintId',
          type: DatatableTableColumnType.NUMBER,
          addIfNotAvailable: true
        },
        {
          key: 'hintCodeId',
          type: DatatableTableColumnType.NUMBER,
          addIfNotAvailable: true
        },
        {
          key: 'displayName',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'externalId',
          type: DatatableTableColumnType.TEXT,
          addIfNotAvailable: true
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    /* Connected occurred consumptions */
    ConnectedOccurredConsumptionsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.locationNumber',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'consumption.externalId',
        'consumption.displayName',
        'consumption.consumptionCodeId'
      ],
      defaultColumns: [
        'occurredConsumptionId',
        'consumption',
        'value',
        'consumption.unit',
        'resource',
        'resource.location',
        'lastModified'
      ],
      columnTypings: [
        {
          key: 'occurredConsumptionId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'consumption',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-consumption',
          idKey: 'consumptionCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedConsumptionCodeService,
          link: (consumption: ConsumptionCodeSimpleListDto) => consumption?.consumptionCodeId ? `/connected/consumption-codes/${ consumption.consumptionCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedConsumption],
          linkPermissions: [AppPermissions.ReadOccurredConnectedConsumption]
        },
        {
          key: 'resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (resource: ResourceSimpleDto) => resource?.resourceId ? `/resources/${ resource.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'resource.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          name: 'location',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationSimpleDto) => location?.locationId ? `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'consumptionCodeId',
          type: DatatableTableColumnType.NUMBER
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'consumption.unit',
          type: DatatableTableColumnType.TEXT,
          name: 'unit'
        }
      ]
    },

    /* Connected occurred errors */
    ConnectedOccurredErrorsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.locationNumber',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'error.errorCodeId',
        'error.externalId',
        'error.displayName',
      ],
      defaultColumns: [
        'occurredErrorId',
        'error',
        'resource',
        'resource.location',
        'lastModified',
        'isActive'
      ],
      columnTypings: [
        {
          key: 'occurredErrorId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'error',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-error',
          idKey: 'errorCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedErrorCodeService,
          link: (error: ErrorCodeSimpleListDto) => error?.errorCodeId ? `/connected/error-codes/${ error.errorCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedError],
          linkPermissions: [AppPermissions.ReadOccurredConnectedError]
        },
        {
          key: 'resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (resource: ResourceSimpleDto) => resource?.resourceId ? `/resources/${ resource.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'resource.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          name: 'location',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationSimpleDto) => location?.locationId ? `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    /* Connected occurred hints */
    ConnectedOccurredHintsDefault: {
      excludedColumns: [
        'eventTime',
        'resource.resourceId',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.locationNumber',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'hint.hintCodeId',
        'hint.displayName',
        'hint.externalId'
      ],
      defaultColumns: [
        'occurredHintId',
        'hint',
        'resource',
        'resource.location',
        'lastModified',
        'isActive'
      ],
      columnTypings: [
        {
          key: 'occurredHintId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id'
        },
        {
          key: 'hint',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-hint',
          idKey: 'hintCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedHintCodeService,
          link: (hint: HintCodeSimpleListDto) => hint?.hintCodeId ? `/connected/hint-codes/${ hint.hintCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedHint],
          linkPermissions: [AppPermissions.ReadOccurredConnectedHint]
        },
        {
          key: 'resource',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'resourceId',
          displayKey: 'name',
          service: CorePortalFeatureResourceService,
          link: (resource: ResourceSimpleDto) => resource?.resourceId ? `/resources/${ resource.resourceId }` : null,
          module: 'inventory',
          permissions: [AppPermissions.ReadResource],
          linkPermissions: [AppPermissions.ReadResource]
        },
        {
          key: 'resource.location',
          type: DatatableTableColumnType.REFERENCE,
          idKey: 'locationId',
          displayKey: 'name',
          name: 'location',
          service: CorePortalFeatureMasterDataLocationService,
          link: (location: LocationSimpleDto) => location?.locationId ? `/masterdata/locations/${ location.locationId }` : null,
          module: 'management',
          permissions: [AppPermissions.ReadLocation],
          linkPermissions: [AppPermissions.ReadLocation]
        },
        {
          key: 'lastModified',
          type: DatatableTableColumnType.DATE,
          utc: true,
          format: 'L LT'
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        }
      ]
    },

    /* Resource Control Protocol Consumptions */
    ResourceControlProtocolConsumptionsDefault: {
      excludedColumns: [
        'resource.resourceId',
        'resource.name',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.name',
        'resource.location.locationNumber',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.name',
        'resource.stereotype.position',
        'resource.stereotype.emoji',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'resource.path.index',
        'resource.path.id',
        'resource.path.name',
        'error.errorCodeId',
        'error.externalId',
        'error.displayName',
        'issues',
        'issues.issueId',
        'issues.title',
        'issues.issueType',
        'issues.reason',
        'issues.reason.type',
        'consumption.externalId',
        'consumption.displayName',
        'consumption.consumptionCodeId',
        'consumption.unit',
        'eventId'
      ],
      defaultColumns: [
        "occurredConnectedConsumptionHistoryId",
        'consumption',
        'code',
        'occuredAt'
      ],
      columnTypings: [
        {
          key: 'occurredConnectedConsumptionHistoryId',
          type: DatatableTableColumnType.NUMBER,
          name: 'id',
          addIfNotAvailable: true
        },
        {
          key: 'code',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'occuredAt',
          type: DatatableTableColumnType.DATE,
          name: 'occurredAt',
          utc: true
        },
        {
          key: 'isArchived',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'consumption',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-consumption',
          idKey: 'consumptionCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedConsumptionCodeService,
          link: (consumption: ConsumptionCodeSimpleListDto) => consumption?.consumptionCodeId ? `/connected/${ consumption.consumptionCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedConsumption],
          linkPermissions: [AppPermissions.ReadOccurredConnectedConsumption]
        },
      ]
    },

    /* Resource Control Protocol Errors */
    ResourceControlProtocolErrorsDefault: {
      excludedColumns: [
        'resource.resourceId',
        'resource.name',
        'resource.inventoryNumberCount',
        'resource.inventoryNumber',
        'resource.locationId',
        'resource.parentId',
        'resource.location.locationId',
        'resource.location.name',
        'resource.location.locationNumber',
        'resource.location.externalId',
        'resource.stereotype.stereotypeId',
        'resource.stereotype.emoji',
        'resource.stereotype.name',
        'resource.stereotype.position',
        'resource.stereotype.tenantId',
        'resource.stereotype.rowVersion',
        'resource.stereotype.isArchived',
        'resource.stereotype.externalId',
        'resource.externalId',
        'resource.path',
        'resource.path.index',
        'resource.path.id',
        'resource.path.name',
        'issues',
        'issues.issueId',
        'issues.title',
        'issues.issueType',
        'issues.reason',
        'issues.reason.type',
        'issues',
        'eventId',
        'error.errorCodeId',
        'error.externalId',
        'error.displayName'
      ],
      defaultColumns: [
        "occurredConnectedErrorHistoryId",
        'error',
        'code',
        'occuredAt'
      ],
      columnTypings: [
        {
          key: "occurredConnectedErrorHistoryId",
          type: DatatableTableColumnType.NUMBER,
          name: "id"
        },
        {
          key: 'code',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'occuredAt',
          type: DatatableTableColumnType.DATE,
          name: 'occurredAt',
          utc: true
        },
        {
          key: 'isActive',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'isArchived',
          type: DatatableTableColumnType.BOOLEAN
        },
        {
          key: 'error',
          type: DatatableTableColumnType.REFERENCE,
          name: 'occurred-error',
          idKey: 'errorCodeId',
          displayKey: 'displayName',
          service: TechPortalFeatureConnectedErrorCodeService,
          link: (error: ErrorCodeSimpleListDto) => error?.errorCodeId ? `/connected/error-codes/${ error.errorCodeId }` : null,
          module: 'settings',
          permissions: [AppPermissions.ReadOccurredConnectedError],
          linkPermissions: [AppPermissions.ReadOccurredConnectedError]
        },
      ]
    },

    /* PowerBi Settings */
    PowerBiSettingsDefault: {
      excludedColumns: [
        'tenantId'
      ],
      defaultColumns: [
        'powerBiSettingId',
        'key',
        'value'
      ],
      columnTypings: [
        {
          key: "powerBiSettingId",
          type: DatatableTableColumnType.NUMBER,
          name: "id"
        },
        {
          key: 'key',
          name: 'key',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'value',
          type: DatatableTableColumnType.TEXT
        }
      ]
    },

    /* Parquet Endpoints */
    ParquetEndpointsDefault: {
      excludedColumns: [],
      defaultColumns: [
        'key',
        'url',
        'lastModified'
      ],
      columnTypings: [
        {
          key: 'key',
          name: 'parquet-key',
          type: DatatableTableColumnType.TEXT
        },
        {
          key: 'url',
          type: DatatableTableColumnType.LINK
        },
        {
          key: 'lastModified',
          name: 'parquet-last-modified',
          type: DatatableTableColumnType.DATE,
          utc: true
        }
      ]
    },

  };
}
